// AUTO-GENERATED CODE, DO NOT EDIT!
//
// These types are generated from the schema
// base types and should not be used
//
/* eslint-disable */

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: any
  DateTime: any
  JSON: any
}

export type AdditionalContact = {
  __typename?: 'AdditionalContact'
  email: Scalars['String']
  id: Scalars['Int']
  listingId: Scalars['Int']
  name: Scalars['String']
  phoneNumber: Scalars['String']
}

export type AdditionalContactInput = {
  email: Scalars['String']
  name: Scalars['String']
  phoneNumber: Scalars['String']
}

export type AdditionalContactUpdateInput = {
  email?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  name?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type AmLeadsFilter = {
  regions?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<Scalars['String']>
}

export type AssignUserToCompanyInput = {
  companyID: Scalars['Int']
  role: Scalars['String']
  status: CompanyUserStatus
  userID: Scalars['Int']
}

export type AssignUserToRoleInput = {
  role: BusinessRoles
  userID: Scalars['Int']
}

export enum Audience {
  Personal = 'personal',
  Professional = 'professional',
}

export type AuthenticateGuestInput = {
  email: Scalars['String']
  password: Scalars['String']
}

export type Avatar = {
  __typename?: 'Avatar'
  normal?: Maybe<Scalars['String']>
  small?: Maybe<Scalars['String']>
  thumb?: Maybe<Scalars['String']>
}

export type Avatars = {
  __typename?: 'Avatars'
  normal?: Maybe<Scalars['String']>
  small?: Maybe<Scalars['String']>
  thumb?: Maybe<Scalars['String']>
}

/** Type of collection / event_type. */
export type Bbbe_Collection = {
  __typename?: 'BBBE_Collection'
  features?: Maybe<Array<Feature>>
  id: Scalars['ID']
  layouts?: Maybe<Array<Scalars['String']>>
  name: Scalars['String']
}

export type Booking = EventAndBookingFields & {
  __typename?: 'Booking'
  additionalNotes?: Maybe<Scalars['String']>
  additionalSpends?: Maybe<Array<Booking>>
  attendees: Scalars['Int']
  /**
   * This could be replaced by a bookingFolder resolver, but recursive resolver querying isn't currently
   * possible in GraphQL, so folder-booking relationships are currently reconstructed in the frontend.
   */
  bookingFolderId?: Maybe<Scalars['Int']>
  /** any user that clicked request to book button */
  bookingRequestedAt?: Maybe<Scalars['DateTime']>
  bookingRequestedBy?: Maybe<User>
  budget: Scalars['Int']
  cateringNeeds?: Maybe<Scalars['String']>
  closedAmount?: Maybe<Scalars['Int']>
  closedAmountCompanyCurrency?: Maybe<Scalars['Int']>
  closedAt?: Maybe<Scalars['DateTime']>
  commissionPercentage?: Maybe<Scalars['Float']>
  commissionableAmount?: Maybe<Scalars['Int']>
  completedAt?: Maybe<Scalars['DateTime']>
  convertedBookingBudget: ConvertedBookingBudget
  country: Scalars['String']
  createdAt: Scalars['DateTime']
  currency: SupportedCurrencyCode
  /** The deadline for procurement information to be finalised. It defaults to one month after creation. */
  decisionDate: Scalars['String']
  event: Event
  /**
   * Optional, in case the booking event-type differs from the parent event's type. Used to stich in
   * the 'Collection' event type entity by the gateway.
   */
  eventType?: Maybe<Collection>
  fastTrackSupplierEmail?: Maybe<Scalars['String']>
  fastTrackSupplierName?: Maybe<Scalars['String']>
  fastTracked?: Maybe<Scalars['Boolean']>
  firstInvitationSentAt?: Maybe<Scalars['String']>
  firstProposalReceivedAt?: Maybe<Scalars['String']>
  firstProposalsSentToGuestAt?: Maybe<Scalars['String']>
  flexibleDatesNote?: Maybe<Scalars['String']>
  /** Event start time as 'zoneless' DateTime */
  fromDateTime: Scalars['DateTime']
  fxRate?: Maybe<Scalars['Float']>
  hubspotID?: Maybe<Scalars['String']>
  id: Scalars['Int']
  invitations: Array<Invitation>
  isAdditionalSpendBooking: Scalars['Boolean']
  isCommisionable?: Maybe<Scalars['Boolean']>
  isFlexibleWithDates: Scalars['Boolean']
  lat: Scalars['Float']
  layoutId: Scalars['String']
  /**
   * This tracks the different phases of bookings. It's updated automatically and used to belong to
   * events.
   */
  lifecycleStage: LifecycleStage
  location: Scalars['String']
  lon: Scalars['Float']
  lostAt?: Maybe<Scalars['String']>
  lostReason?: Maybe<Scalars['String']>
  managementStatus: ManagementStatus
  marketPrice?: Maybe<Scalars['Int']>
  name: Scalars['String']
  /** The HeadBox staff member currently responsible for the event. */
  owner?: Maybe<User>
  parentBookingId?: Maybe<Scalars['Int']>
  paymentsInvoiceReference?: Maybe<Scalars['String']>
  /** Determines the booking's order within the current folder or event. */
  position: Scalars['Int']
  processingFeePercentage?: Maybe<Scalars['Float']>
  proposals: Array<Proposal>
  radius: Scalars['Float']
  region: Scalars['String']
  releaseReason?: Maybe<EventReleaseReason>
  requestedToBookAt?: Maybe<Scalars['DateTime']>
  requestedToBookProposal?: Maybe<Proposal>
  solutionsInvoiceReference?: Maybe<Scalars['String']>
  source: Scalars['String']
  spaceFacilities: Array<SpaceFacility>
  styles: Array<Style>
  /**
   * The user who originally created the event (either the guest or a HeadBox staff member). It's
   * nullable as, for some reason, it wasn't being populated before the "2.0" overhaul work.
   */
  submitter?: Maybe<User>
  /**
   * Determines the kind of suppliers relevant for the booking, such as venues, catering,
   * etc.
   */
  supplierType: SupplierType
  supplierTypeEditable: Scalars['Boolean']
  takeOver: Scalars['Boolean']
  takeOverFee?: Maybe<Scalars['Int']>
  takeOverFeePercentage?: Maybe<Scalars['Float']>
  /** Event end time as 'zoneless' DateTime */
  toDateTime: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type BookingConvertedBookingBudgetArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type BookingInvitationsArgs = {
  filter?: InputMaybe<InvitationsFilter>
}

export type BookingProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>
}

export enum BookingIntent {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

export type BookingsFilter = {
  archived?: InputMaybe<Scalars['Boolean']>
  confirmedBooking?: InputMaybe<Scalars['Boolean']>
  eventId?: InputMaybe<Scalars['Int']>
  eventUuid?: InputMaybe<Scalars['String']>
  excludedStatuses?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['Int']>
  invitedServiceIds?: InputMaybe<Array<Scalars['Int']>>
  restrictToUser?: InputMaybe<Scalars['Boolean']>
  upcomingOnly?: InputMaybe<Scalars['Boolean']>
  uuid?: InputMaybe<Scalars['String']>
}

export type BookingsFolder = {
  __typename?: 'BookingsFolder'
  bookingsFolderBudget: ConvertedAmount
  budget?: Maybe<Scalars['Int']>
  event: Event
  /** Optional categorisation of the folder by the event type. */
  eventType?: Maybe<Collection>
  id: Scalars['Int']
  name: Scalars['String']
  /** The position of the folder within the current folder (if parentFolder defined) or event. */
  notes?: Maybe<Scalars['String']>
  /**
   * This could be replaced by parentFolder and childFolders resolvers, but recursive resolver querying
   * isn't currently possible in GraphQL, so folder hierarchies are currently reconstructed in the
   * frontend.
   */
  parentFolderId?: Maybe<Scalars['Int']>
  position: Scalars['Int']
}

export type BotResearchJobResponse = {
  __typename?: 'BotResearchJobResponse'
  jobId: Scalars['String']
}

/** Type of a normal brief. */
export type Brief = {
  __typename?: 'Brief'
  additionalNotes?: Maybe<Scalars['String']>
  /** Is this a personal or professional event? */
  audience?: Maybe<Audience>
  /** How likely is the guest to book? */
  bookingIntent?: Maybe<BookingIntent>
  budget: Scalars['Float']
  budgetGuidanceAverage?: Maybe<Scalars['Int']>
  budgetGuidanceBasic?: Maybe<Scalars['Int']>
  budgetGuidanceHighEnd?: Maybe<Scalars['Int']>
  budgetNotes?: Maybe<Scalars['String']>
  capacities: Scalars['Int']
  /** Archived */
  catering?: Maybe<Array<Scalars['String']>>
  cateringNeeds?: Maybe<Scalars['String']>
  collection: Scalars['JSON']
  collectionName: Scalars['String']
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  currency: Scalars['String']
  /** Deal ID on Hubspot */
  dealId?: Maybe<Scalars['String']>
  /** Event From (Full DateTime) */
  eventDateFrom: Scalars['String']
  /** Event To (Full DateTime) */
  eventDateTo: Scalars['String']
  eventName: Scalars['String']
  /** @deprecated Superceded by isFlexibleOnDate and isFlexibleOnTime in Lead Feed */
  flexibleDates: Scalars['Boolean']
  /** Additional notes on flexibility. Used with legacy flexible_dates and new flexible_on_date/time fields */
  flexibleDatesNote?: Maybe<Scalars['String']>
  fromDate: Scalars['String']
  fromTime: Scalars['String']
  guest: BriefGuest
  /** Guest (User) ID */
  guestId: Scalars['ID']
  /** Host (User) ID */
  hostId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  /** Date-specific flexibility field for Lead Feed */
  isFlexibleOnDate?: Maybe<Scalars['Boolean']>
  /** Time-specific flexibility field for Lead Feed */
  isFlexibleOnTime?: Maybe<Scalars['Boolean']>
  lat: Scalars['Float']
  layout: Scalars['String']
  leadFeedCity?: Maybe<Scalars['String']>
  location: Scalars['String']
  lon: Scalars['Float']
  /** The maximum number of undeclined messages this brief will be able to receive. The value comes from e-tenders */
  messageLimit?: Maybe<Scalars['Int']>
  numonce?: Maybe<Scalars['Int']>
  /** The space facilities considered desirable by the guest */
  optionalSpaceFacilities: Array<SpaceFacility>
  public: Scalars['Boolean']
  radius: Scalars['Float']
  /** The space facilities considered essential by the guest */
  requiredSpaceFacilities: Array<SpaceFacility>
  /**
   * List of all space facilities
   * @deprecated Lead Feed now distuinguishes between optional and required facilities
   */
  spaceFacilities: Array<SpaceFacility>
  spaceId?: Maybe<Scalars['ID']>
  status: Scalars['String']
  styleIds: Array<Scalars['String']>
  tier: Scalars['String']
  toDate: Scalars['String']
  toTime: Scalars['String']
  /** Guest (User) ID */
  userId: Scalars['ID']
  virtual: Scalars['Boolean']
}

/**
 * Attributes for creating or updating a brief.
 *     Also means what we get from BriefBuidler FrontEnd.
 */
export type BriefAttributes = {
  additionalNotes?: InputMaybe<Scalars['String']>
  /** Specify whether this is a personal or professional event */
  audience?: InputMaybe<Audience>
  /** An indication of how likely a guest is to book */
  bookingIntent?: InputMaybe<BookingIntent>
  budget: Scalars['Int']
  budgetGuidanceAverage?: InputMaybe<Scalars['Int']>
  budgetGuidanceBasic?: InputMaybe<Scalars['Int']>
  budgetGuidanceHighEnd?: InputMaybe<Scalars['Int']>
  budgetNotes?: InputMaybe<Scalars['String']>
  bypassAutomation?: InputMaybe<Scalars['Boolean']>
  capacities: Scalars['Int']
  catering?: InputMaybe<Array<Scalars['String']>>
  cateringNeeds?: InputMaybe<Scalars['String']>
  collection?: InputMaybe<Scalars['String']>
  collectionName?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  /** A list of content pages visted prior to submitting brief */
  enquiryContentPageSources?: InputMaybe<Array<Scalars['String']>>
  eventName?: InputMaybe<Scalars['String']>
  /** Deprecated: use requiredSpaceFacilityIds and/or optionalSpaceFacilityIds instead. */
  facilities?: InputMaybe<Array<Scalars['String']>>
  /** Deprecated: this parameter is completely ignored. */
  facilitiesList?: InputMaybe<Array<Scalars['String']>>
  /** Deprecated: superceded by isFlexibleOnDate/Time fields for Lead Feed */
  flexibleDates?: InputMaybe<Scalars['Boolean']>
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDate?: InputMaybe<Scalars['String']>
  fromTime?: InputMaybe<Scalars['String']>
  hostId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Int']>
  isFlexibleOnDate?: InputMaybe<Scalars['Boolean']>
  isFlexibleOnTime?: InputMaybe<Scalars['Boolean']>
  lat: Scalars['String']
  layouts?: InputMaybe<Scalars['String']>
  leadFeedCity?: InputMaybe<Scalars['String']>
  location: Scalars['String']
  lon: Scalars['String']
  numonce?: InputMaybe<Scalars['Int']>
  /** IDs for the facilities considered 'desirable' by the user */
  optionalSpaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  public?: InputMaybe<Scalars['Boolean']>
  qualifiesForConcierge?: InputMaybe<Scalars['Boolean']>
  radius?: InputMaybe<Scalars['Float']>
  /** IDs for the facilities considered 'essential' by the user */
  requiredSpaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  /** Deprecated: use requiredSpaceFacilityIds and/or optionalSpaceFacilityIds instead. */
  spaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  spaceId?: InputMaybe<Scalars['String']>
  styleIds?: InputMaybe<Array<Scalars['String']>>
  tier?: InputMaybe<Scalars['String']>
  toDate?: InputMaybe<Scalars['String']>
  toTime?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['Int']>
  virtual?: InputMaybe<Scalars['Boolean']>
}

/** Type of a guest user who created the brief. */
export type BriefGuest = {
  __typename?: 'BriefGuest'
  company: Scalars['String']
  country?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  id: Scalars['ID']
  isBusinessUser: Scalars['Boolean']
  lastName: Scalars['String']
  mobileNumber?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
}

export type BriefIsAutomatableResponse = {
  __typename?: 'BriefIsAutomatableResponse'
  /** Whether the brief is automatable. */
  isAutomatable: Scalars['Boolean']
}

export type BriefLatLon = {
  lat: Scalars['Float']
  lon: Scalars['Float']
}

export enum BusinessRoles {
  Administrator = 'administrator',
  Manager = 'manager',
  Member = 'member',
}

/** Full type merged into the schema in the gateway */
export type Collection = {
  __typename?: 'Collection'
  id: Scalars['Int']
  label: Scalars['String']
  name: Scalars['String']
}

export type CompaniesFilter = {
  countries?: InputMaybe<Array<HeadBoxCountry>>
  ids?: InputMaybe<Array<Scalars['Int']>>
}

export type Company = {
  __typename?: 'Company'
  ID: Scalars['Int']
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  contract?: Maybe<CompanyContract>
  country?: Maybe<HeadBoxCountry>
  currency: Scalars['String']
  domainTriageEnabled?: Maybe<Scalars['Boolean']>
  domains: Array<Scalars['String']>
  hideAdditionalSpendInGraphs: Scalars['Boolean']
  hideSoftSavings: Scalars['Boolean']
  id: Scalars['Int']
  isContracted?: Maybe<Scalars['Boolean']>
  logo?: Maybe<Scalars['String']>
  logo_curated?: Maybe<Scalars['String']>
  members: Array<CompanyUser>
  name: Scalars['String']
  postcode?: Maybe<Scalars['String']>
  teams: Array<CompanyTeam>
}

export type CompanyContract = {
  __typename?: 'CompanyContract'
  agreementEndDate?: Maybe<Scalars['DateTime']>
  agreementStartDate?: Maybe<Scalars['DateTime']>
  company: Company
  contractEndDate?: Maybe<Scalars['DateTime']>
  contractStartDate?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  discountModel: Array<DiscountModelRow>
  discountModelNotes?: Maybe<Scalars['String']>
  feesNotes?: Maybe<Scalars['String']>
  id: Scalars['Int']
  implementationFee?: Maybe<Scalars['String']>
  internationalFee?: Maybe<Scalars['String']>
  managementFee?: Maybe<Scalars['Float']>
  nonCommissionableBookingFee?: Maybe<Scalars['String']>
  takeoverFee?: Maybe<Scalars['String']>
}

export type CompanyTeam = {
  __typename?: 'CompanyTeam'
  ID: Scalars['Int']
  name: Scalars['String']
}

export type CompanyUser = {
  __typename?: 'CompanyUser'
  ID: Scalars['Int']
  company: Company
  status: Scalars['String']
  user: User
}

export enum CompanyUserStatus {
  AccessRequest = 'access_request',
  Active = 'active',
  Pending = 'pending',
  Suspended = 'suspended',
}

export type ContractInput = {
  agreementEndDate?: InputMaybe<Scalars['DateTime']>
  agreementStartDate?: InputMaybe<Scalars['DateTime']>
  contractEndDate?: InputMaybe<Scalars['DateTime']>
  contractStartDate?: InputMaybe<Scalars['DateTime']>
  discountModel?: InputMaybe<Array<DiscountModelRowInput>>
  discountModelNotes?: InputMaybe<Scalars['String']>
  feesNotes?: InputMaybe<Scalars['String']>
  implementationFee?: InputMaybe<Scalars['String']>
  internationalFee?: InputMaybe<Scalars['String']>
  managementFee?: InputMaybe<Scalars['Float']>
  nonCommissionableBookingFee?: InputMaybe<Scalars['String']>
  takeoverFee?: InputMaybe<Scalars['String']>
}

export type ConvertedAmount = {
  __typename?: 'ConvertedAmount'
  currency: Currency
  value: Scalars['Float']
}

export type ConvertedBaseCostTotal = {
  __typename?: 'ConvertedBaseCostTotal'
  inBookingCurrency: ConvertedAmount
  inCompanyCurrency?: Maybe<ConvertedAmount>
  inEventCurrency?: Maybe<ConvertedAmount>
  inProposalCurrency: ConvertedAmount
  inTargetCurrency?: Maybe<ConvertedAmount>
}

export type ConvertedBookingBudget = {
  __typename?: 'ConvertedBookingBudget'
  inBookingCurrency: ConvertedAmount
  inCompanyCurrency?: Maybe<ConvertedAmount>
  inEventCurrency: ConvertedAmount
  inTargetCurrency?: Maybe<ConvertedAmount>
}

export type ConvertedEventBudget = {
  __typename?: 'ConvertedEventBudget'
  inCompanyCurrency?: Maybe<ConvertedAmount>
  inEventCurrency: ConvertedAmount
  inTargetCurrency?: Maybe<ConvertedAmount>
}

export type CostItemQtyIn = {
  ID: Scalars['Int']
  quantity: Scalars['Int']
}

export type CreateAccountUserDetailsInput = {
  contactNumber: Scalars['String']
  country?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  requestsExtraMarketingContent: Scalars['Boolean']
}

export type CreateAdditionalSpendInput = {
  budget: Scalars['Int']
  currency: Scalars['String']
  name: Scalars['String']
  parentBookingId: Scalars['Int']
}

export type CreateBookingInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees: Scalars['Int']
  bookingFolderId?: InputMaybe<Scalars['Int']>
  bookingRequestedAt?: InputMaybe<Scalars['String']>
  bookingRequestedBy?: InputMaybe<Scalars['Int']>
  budget: Scalars['Int']
  cateringNeeds?: InputMaybe<Scalars['String']>
  closedAmount?: InputMaybe<Scalars['Int']>
  closedAmountCompanyCurrency?: InputMaybe<Scalars['Int']>
  closedAmountExTax?: InputMaybe<Scalars['Int']>
  closedAt?: InputMaybe<Scalars['String']>
  commissionPercentage?: InputMaybe<Scalars['Float']>
  commissionableAmount?: InputMaybe<Scalars['Int']>
  completedAt?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  currency: Scalars['String']
  eventId: Scalars['Int']
  eventTypeId?: InputMaybe<Scalars['Int']>
  fastTrackSupplierEmail?: InputMaybe<Scalars['String']>
  fastTrackSupplierName?: InputMaybe<Scalars['String']>
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDateTime: Scalars['String']
  fxRate?: InputMaybe<Scalars['Float']>
  hubspotID?: InputMaybe<Scalars['String']>
  isAdditionalSpendBooking?: InputMaybe<Scalars['Boolean']>
  isCommisionable?: InputMaybe<Scalars['Boolean']>
  isFlexibleWithDates: Scalars['Boolean']
  lat: Scalars['Float']
  layoutId: Scalars['String']
  location: Scalars['String']
  lon: Scalars['Float']
  lostReason?: InputMaybe<Scalars['String']>
  marketPrice?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
  parentBookingId?: InputMaybe<Scalars['Int']>
  paymentsInvoiceReference?: InputMaybe<Scalars['String']>
  processingFeePercentage?: InputMaybe<Scalars['Float']>
  radius: Scalars['Float']
  releaseReason?: InputMaybe<EventReleaseReason>
  requestedToBookAt?: InputMaybe<Scalars['String']>
  solutionsInvoiceReference?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIds: Array<Scalars['Int']>
  styleIds: Array<Scalars['String']>
  submittedBy?: InputMaybe<Scalars['Int']>
  supplierType: Scalars['String']
  takeOver?: InputMaybe<Scalars['Boolean']>
  takeOverFee?: InputMaybe<Scalars['Int']>
  takeOverFeePercentage?: InputMaybe<Scalars['Float']>
  toDateTime: Scalars['String']
}

export type CreateBookingsFolderInput = {
  budget?: InputMaybe<Scalars['Int']>
  eventId: Scalars['Int']
  eventTypeId?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  parentFolderId?: InputMaybe<Scalars['Int']>
  position: Scalars['Int']
}

export type CreateBusinessGuestAccountInput = {
  password: Scalars['String']
  userDetails: CreateAccountUserDetailsInput
}

export type CreateCompanyInput = {
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<ContractInput>
  country?: InputMaybe<HeadBoxCountry>
  currency: Scalars['String']
  domainTriageEnabled?: InputMaybe<Scalars['Boolean']>
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  hideAdditionalSpendInGraphs?: InputMaybe<Scalars['Boolean']>
  hideSoftSavings?: InputMaybe<Scalars['Boolean']>
  isContracted?: InputMaybe<Scalars['Boolean']>
  logo?: InputMaybe<Scalars['String']>
  logo_curated?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  postcode?: InputMaybe<Scalars['String']>
}

export type CreateEventInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees: Scalars['Int']
  automatedInvitationsBypassed?: InputMaybe<Scalars['Boolean']>
  automatedInvitationsQualified?: InputMaybe<Scalars['Boolean']>
  budget: Scalars['Int']
  cateringNeeds?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  currency: Scalars['String']
  eventTypeID: Scalars['Int']
  flexibleDatesNote: Scalars['String']
  fromDateTime: Scalars['String']
  guestCompany: Scalars['String']
  guestID: Scalars['Int']
  isFlexibleWithDates: Scalars['Boolean']
  lat: Scalars['String']
  layoutID: Scalars['String']
  location: Scalars['String']
  lon: Scalars['String']
  name: Scalars['String']
  ownerId?: InputMaybe<Scalars['Int']>
  radius: Scalars['String']
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIDs: Array<Scalars['Int']>
  styleIDs?: InputMaybe<Array<Scalars['String']>>
  toDateTime: Scalars['String']
}

export type CreateEventNoteInput = {
  eventID: Scalars['Int']
  note: Scalars['String']
}

export type CreateFullListingInput = {
  additionalContacts: Array<AdditionalContactInput>
  listing: CreateListingInput
}

export type CreateHostAccountInput = {
  password: Scalars['String']
  userDetails: CreateAccountUserDetailsInput
}

export type CreateListingInput = {
  address: Scalars['String']
  commissionDetails?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  description: Scalars['String']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: ListingSupplierType
  sustainabilityIds: Array<Scalars['Int']>
  userId: Scalars['Int']
  websiteUrl: Scalars['String']
}

export type CreateProposalInput = {
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  bookingId: Scalars['Int']
  currency: Scalars['String']
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  eventId: Scalars['Int']
  extraCostItems?: InputMaybe<Array<ExtraCostItemInput>>
  fromDateTime: Scalars['String']
  invitationID: Scalars['Int']
  message?: InputMaybe<Scalars['String']>
  selectedPhotos?: InputMaybe<Array<Scalars['Int']>>
  serviceId: Scalars['Int']
  serviceType: ServiceProviderType
  spaceID?: InputMaybe<Scalars['Int']>
  toDateTime: Scalars['String']
  tourCoverUrl?: InputMaybe<Scalars['String']>
  tourUrl?: InputMaybe<Scalars['String']>
  venueName?: InputMaybe<Scalars['String']>
}

export type CreateStandardGuestAccountInput = {
  password?: InputMaybe<Scalars['String']>
  userDetails: CreateAccountUserDetailsInput
}

export type CreateSupplierAccountInput = {
  password: Scalars['String']
  userDetails: CreateAccountUserDetailsInput
}

export type CreateSupplierDealInput = {
  attachmentFilePaths?: InputMaybe<Array<Scalars['String']>>
  cost?: InputMaybe<Scalars['Int']>
  currency: Scalars['String']
  eventID: Scalars['Int']
  message?: InputMaybe<Scalars['String']>
  supplierID: Scalars['Int']
}

export type CreateSupplierInput = {
  email: Scalars['String']
  name: Scalars['String']
  type: SupplierType
}

export type CreatedListing = {
  __typename?: 'CreatedListing'
  additionalContacts: Array<AdditionalContact>
  address: Scalars['String']
  commissionDetails?: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Scalars['String']
  deletedAt?: Maybe<Scalars['String']>
  description: Scalars['String']
  id: Scalars['Int']
  latitude: Scalars['Float']
  listingDocuments: Array<UploadedDocumentResponse>
  listingImages: Array<UploadedImageResponse>
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: ListingSupplierType
  sustainabilityIds: Array<Scalars['Int']>
  updatedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  user: User
  userId: Scalars['Int']
  websiteUrl: Scalars['String']
}

export type Currency = {
  __typename?: 'Currency'
  code: SupportedCurrencyCode
  order: Scalars['Int']
  symbol: Scalars['String']
}

/** If either 'from' or 'to' are null, there will be no lower or upper bound respectively */
export type DateRangeFilter = {
  from?: InputMaybe<Scalars['DateTime']>
  to?: InputMaybe<Scalars['DateTime']>
}

export type DeclineProposalsInput = {
  declinedMessage?: InputMaybe<Scalars['String']>
  declinedReason: Array<ProposalDeclinedReason>
  proposalIds: Array<Scalars['Int']>
}

export type DeleteEventNoteInput = {
  ID: Scalars['Int']
}

export type DeleteSupplierDealInput = {
  ID: Scalars['Int']
}

export type DeleteSupplierInput = {
  ID: Scalars['Int']
}

export type DiscountModelRow = {
  __typename?: 'DiscountModelRow'
  contract?: Maybe<CompanyContract>
  managementFeeDiscount?: Maybe<Scalars['Float']>
  maxSpend?: Maybe<Scalars['Int']>
  minSpend?: Maybe<Scalars['Int']>
}

export type DiscountModelRowInput = {
  managementFeeDiscount?: InputMaybe<Scalars['Float']>
  maxSpend?: InputMaybe<Scalars['Int']>
}

export type EditCompanyInput = {
  ID: Scalars['Int']
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<ContractInput>
  country?: InputMaybe<HeadBoxCountry>
  currency: Scalars['String']
  domainTriageEnabled?: InputMaybe<Scalars['Boolean']>
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  hideAdditionalSpendInGraphs?: InputMaybe<Scalars['Boolean']>
  hideSoftSavings?: InputMaybe<Scalars['Boolean']>
  isContracted?: InputMaybe<Scalars['Boolean']>
  logo?: InputMaybe<Scalars['String']>
  logo_curated?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  postcode?: InputMaybe<Scalars['String']>
}

export type EmissionsByPeriod = {
  __typename?: 'EmissionsByPeriod'
  date: Scalars['DateTime']
  totalAttendees: Scalars['Int']
  totalEmissions: Scalars['Float']
  totalEmissionsPerAttendee: Scalars['Float']
}

export type EmissionsFilter = {
  periodType?: InputMaybe<EmissionsPeriodType>
}

export enum EmissionsPeriodType {
  Day = 'DAY',
  Month = 'MONTH',
}

export enum EpcRating {
  A = 'A',
  APlus = 'A_PLUS',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
}

export type Event = EventAndBookingFields & {
  __typename?: 'Event'
  /** @deprecated Use id */
  ID: Scalars['Int']
  UUID: Scalars['ID']
  /** @deprecated Use `owner` instead */
  accountManager?: Maybe<User>
  actualEventMgmtFee?: Maybe<Scalars['Int']>
  additionalNotes?: Maybe<Scalars['String']>
  attendees: Scalars['Int']
  /** @deprecated This value now resides on the associated bookings */
  bookingRequestedAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings */
  bookingRequestedBy?: Maybe<Scalars['Int']>
  bookings: Array<Booking>
  bookingsFolders: Array<BookingsFolder>
  budget: Scalars['Int']
  cateringNeeds?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  closedAmount?: Maybe<Scalars['Int']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  closedAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings */
  commissionPerc?: Maybe<Scalars['Float']>
  committedEventBudget: ConvertedEventBudget
  company: Company
  /** The company ID is used to stitch in a company resolver in the gateway */
  companyId: Scalars['Int']
  /** @deprecated This value now resides on the associated bookings */
  completedAt?: Maybe<Scalars['String']>
  convertedEventBudget: ConvertedEventBudget
  /** The brief location country, not the company country. Prior to 2024, the two were conflated. */
  country: Scalars['String']
  createdAt?: Maybe<Scalars['DateTime']>
  currency: SupportedCurrencyCode
  decisionDate: Scalars['String']
  estimatedEventMgmtFee?: Maybe<Scalars['Int']>
  eventType: Collection
  /** @deprecated This can be derived from the invitations of each booking */
  firstInvitationSentAt?: Maybe<Scalars['String']>
  /** @deprecated This can be derived from the proposals of each booking */
  firstProposalReceivedAt?: Maybe<Scalars['String']>
  /** @deprecated This can be derived from the proposals of each booking */
  firstProposalsSentToGuestAt?: Maybe<Scalars['String']>
  flexibleDatesNote?: Maybe<Scalars['String']>
  /** @deprecated Use 'isFlexibleWithDates' */
  flexibleWithDates: Scalars['Boolean']
  /** @deprecated Use 'flexibleDatesNote' */
  flexibleWithDatesNote?: Maybe<Scalars['String']>
  fromDateTime: Scalars['String']
  guest: User
  id: Scalars['Int']
  /** Returns the invitations for every associated booking */
  invitations: Array<Invitation>
  isFlexibleWithDates: Scalars['Boolean']
  isSimpleEvent: Scalars['Boolean']
  kanbanColumn: KanbanStatus
  lat: Scalars['String']
  layoutID: Scalars['String']
  location: Scalars['String']
  lon: Scalars['String']
  /** @deprecated This value is no longer required. */
  lostAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  lostReason?: Maybe<Scalars['String']>
  /** A simple descriptive status derived from the combined statuses of the events bookings */
  managementStatus: ManagementStatus
  name: Scalars['String']
  notes?: Maybe<Array<EventNote>>
  /** The HeadBox staff member currently responsible for the event. */
  owner?: Maybe<User>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  paymentsInvoiceReference?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings */
  processingFeePerc?: Maybe<Scalars['Float']>
  proposalCount: Scalars['Int']
  /** Returns the proposals for every associated booking's invitations */
  proposals: Array<Proposal>
  radius?: Maybe<Scalars['String']>
  region: Scalars['String']
  releaseReason?: Maybe<EventReleaseReason>
  /** @deprecated This value now resides on the associated bookings */
  requestedToBookAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  solutionsInvoiceReference?: Maybe<Scalars['String']>
  source: Scalars['String']
  spaceFacilities: Array<SpaceFacility>
  /** @deprecated See the kanbanColumn or associated booking statuses instead */
  status: EventStatus
  styles: Array<Style>
  submittedAt: Scalars['String']
  /** @deprecated Suppliers have been completely overhauled */
  supplierDeals?: Maybe<Array<SupplierDeal>>
  /** The team ID to which costs are to be allocated. Consider renaming this field. */
  team?: Maybe<Team>
  toDateTime: Scalars['String']
  updatedAt?: Maybe<Scalars['String']>
}

export type EventCommittedEventBudgetArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type EventConvertedEventBudgetArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type EventProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>
}

export enum EventActiveArg {
  Active = 'Active',
  AllEvents = 'AllEvents',
  Inactive = 'Inactive',
}

export type EventAndBookingFields = {
  additionalNotes?: Maybe<Scalars['String']>
  attendees: Scalars['Int']
  cateringNeeds?: Maybe<Scalars['String']>
  country: Scalars['String']
  currency: SupportedCurrencyCode
  eventType?: Maybe<Collection>
  flexibleDatesNote?: Maybe<Scalars['String']>
  id: Scalars['Int']
  invitations: Array<Invitation>
  isFlexibleWithDates: Scalars['Boolean']
  location: Scalars['String']
  name: Scalars['String']
  owner?: Maybe<User>
  proposals: Array<Proposal>
  source: Scalars['String']
  spaceFacilities: Array<SpaceFacility>
  styles: Array<Style>
}

export type EventAndBookingFieldsProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>
}

export enum EventBucketFilterHost {
  Archived = 'Archived',
  Bookings = 'Bookings',
  Invitations = 'Invitations',
  Proposals = 'Proposals',
}

export type EventNote = {
  __typename?: 'EventNote'
  ID: Scalars['Int']
  note: Scalars['String']
}

export enum EventReleaseReason {
  BookedDirectly = 'BookedDirectly',
  CancelledByBooker = 'CancelledByBooker',
  Duplicate = 'Duplicate',
  EventCancelled = 'EventCancelled',
  EventHeldInternally = 'EventHeldInternally',
  NoResponse = 'NoResponse',
  ScopingExercise = 'ScopingExercise',
}

export type EventSortArg = {
  fromDateTimeAscending?: InputMaybe<Scalars['Boolean']>
}

export enum EventStatus {
  AwaitingDecision = 'AwaitingDecision',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Completed = 'Completed',
  Created = 'Created',
  HostsInvited = 'HostsInvited',
  Lost = 'Lost',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoInvitations = 'NoInvitations',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponseChosen = 'NoResponseChosen',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponses = 'NoResponses',
  ProposalsReceived = 'ProposalsReceived',
  ProposalsSent = 'ProposalsSent',
  RequestedToBook = 'RequestedToBook',
}

export type EventsFilter = {
  activeForAdmin?: InputMaybe<Scalars['Boolean']>
  /** Events booked by the guest IDs */
  bookerIds?: InputMaybe<Array<Scalars['Int']>>
  /** Events closed between the provided range */
  closedAt?: InputMaybe<DateRangeFilter>
  companyIds?: InputMaybe<Array<Scalars['Int']>>
  /** Filters events by the associated companies' countries */
  countries?: InputMaybe<Array<HeadBoxCountry>>
  /** Events created between the provided range */
  createdAt?: InputMaybe<DateRangeFilter>
}

export type EventsPagination = {
  /**
   * For pages after the "first", specify the ID of the last event in the previous page - this is a
   * more reliable means of specifying the page offset.
   */
  lastPaginatedEventId?: InputMaybe<Scalars['Int']>
  order: PaginationOrder
  pageSize: Scalars['Int']
  sortColumn: EventsPaginationSortColumns
}

/**
 * The event column names by which to sort records within the page set. All options will be
 * secondarily sorted by ID (in case of duplicate values)
 */
export enum EventsPaginationSortColumns {
  CreatedAt = 'createdAt',
  FromDateTime = 'fromDateTime',
  UpdatedAt = 'updatedAt',
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate'
  currency: Currency
  rate: Scalars['Float']
}

export type ExtraCostItem = {
  __typename?: 'ExtraCostItem'
  ID: Scalars['Int']
  costPerUnit: Scalars['Int']
  description: Scalars['String']
  quantity?: Maybe<Scalars['Int']>
}

export type ExtraCostItemInput = {
  ID?: InputMaybe<Scalars['Int']>
  costPerUnit: Scalars['Int']
  description: Scalars['String']
}

export type FacilityCategory = {
  __typename?: 'FacilityCategory'
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
  searchable?: Maybe<Scalars['Boolean']>
}

export type FastTrackSpaceInput = {
  collections: Array<InputMaybe<Scalars['Int']>>
  configurations: Array<InputMaybe<SpaceSpatialConfigurationInput>>
  facilities: Array<InputMaybe<Scalars['Int']>>
  photos?: InputMaybe<Array<InputMaybe<SpacePhotoInput>>>
  summary: SpaceSummaryInput
}

export type FastTrackVenueInput = {
  host: HostInput
  space: FastTrackSpaceInput
  venue: VenueInput
}

/** Type of features of collection. */
export type Feature = {
  __typename?: 'Feature'
  id: Scalars['ID']
  name: Scalars['String']
  position: Scalars['Int']
}

export type FeatureCategory = {
  __typename?: 'FeatureCategory'
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
  searchable?: Maybe<Scalars['Boolean']>
}

export type GeolocationFilterInput = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  radiusMeters: Scalars['Int']
}

export type GetAllHostsInfoArgs = {
  eventTypeID?: InputMaybe<Scalars['Int']>
}

export type GetSustainabilityInitiativesForVenueInput = {
  /**
   * The order in which the Sustainability Initiatives should be sorted.
   *
   * Every item in the array must be a valid Sustainability Initative ID (as an integer). If the array is not provided,
   * the Sustainability Initatives will not be sorted.
   */
  orderOfSustainabilityInitatives: Array<Scalars['Int']>
  /** The ID of the venue for which the Sustainability Initiatives are requested. */
  venueId: Scalars['Int']
}

export type GoogleAddress = {
  __typename?: 'GoogleAddress'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  county?: Maybe<Scalars['String']>
  postCode?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  streetNumber?: Maybe<Scalars['String']>
}

export type GuestType = {
  __typename?: 'GuestType'
  hasExistingAccount: Scalars['Boolean']
  isBusinessUser: Scalars['Boolean']
  isDomainValid: Scalars['Boolean']
  userId?: Maybe<Scalars['Int']>
}

export enum HeadBoxCountry {
  Au = 'AU',
  Gb = 'GB',
  Ie = 'IE',
  It = 'IT',
  Nl = 'NL',
  Us = 'US',
}

export type Host = {
  __typename?: 'Host'
  email: Scalars['String']
  id: Scalars['Int']
  isPowerHost: Scalars['Boolean']
  isSmartBookHost: Scalars['Boolean']
}

export type HostContact = {
  __typename?: 'HostContact'
  avatar?: Maybe<Avatar>
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  phoneNumber?: Maybe<Scalars['String']>
}

export type HostInfo = {
  __typename?: 'HostInfo'
  eventTypes: Array<Scalars['Int']>
  hostID: Scalars['Int']
  isSelfServeHost: Scalars['Boolean']
  user: User
  venues: Array<SelfServeVenue>
}

export type HostInput = {
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
}

export type Invitation = {
  __typename?: 'Invitation'
  ID: Scalars['Int']
  bookingId: Scalars['Int']
  createdAt: Scalars['String']
  declinedAt?: Maybe<Scalars['String']>
  declinedReason?: Maybe<InvitationDeclinedReason>
  declinedReasonDetails?: Maybe<Scalars['String']>
  event: Event
  isReadByRecipient: Scalars['Boolean']
  proposals?: Maybe<Array<Proposal>>
  recipient?: Maybe<ServiceProvider>
  recipientId: Scalars['Int']
  recipientType: ServiceProviderType
  space?: Maybe<SelfServeSpace>
  venue?: Maybe<SelfServeVenue>
}

export enum InvitationDeclinedReason {
  CateringRequirements = 'CateringRequirements',
  FacilitiesRequirements = 'FacilitiesRequirements',
  LowBudget = 'LowBudget',
  NoAvailability = 'NoAvailability',
  Other = 'Other',
}

export enum InvitationFilterDeclined {
  Any = 'Any',
  DeclinedOnly = 'DeclinedOnly',
  UndeclinedOnly = 'UndeclinedOnly',
}

export type InvitationsFilter = {
  ignoreInvitationsWithProposals?: InputMaybe<Scalars['Boolean']>
  invitationStatusFilter?: InputMaybe<InvitationFilterDeclined>
  restrictToUser?: InputMaybe<Scalars['Boolean']>
}

export enum KanbanStatus {
  BackfilledFromHubSpot = 'BackfilledFromHubSpot',
  Complete = 'Complete',
  FastTracked = 'FastTracked',
  NewEvent = 'NewEvent',
  ProposalReview = 'ProposalReview',
  ProposalsSent = 'ProposalsSent',
  Released = 'Released',
  RequestedToBook = 'RequestedToBook',
  Sourcing = 'Sourcing',
  Takeover = 'Takeover',
}

export type LeadsPage = {
  __typename?: 'LeadsPage'
  /** Infomation of this current page. */
  pages: Page
  /** Rows of AM leads. */
  rows: Array<Brief>
  /** Total number of pages. */
  totalPages: Scalars['Int']
  /** Totla number of AM leads. */
  totalRows: Scalars['Int']
}

export enum LifecycleStage {
  AwaitingDecision = 'AwaitingDecision',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Completed = 'Completed',
  Created = 'Created',
  HostsInvited = 'HostsInvited',
  Lost = 'Lost',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoInvitations = 'NoInvitations',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponseChosen = 'NoResponseChosen',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponses = 'NoResponses',
  ProposalsReceived = 'ProposalsReceived',
  ProposalsSent = 'ProposalsSent',
  RequestedToBook = 'RequestedToBook',
}

export type Listing = {
  __typename?: 'Listing'
  additionalContacts: Array<AdditionalContact>
  address: Scalars['String']
  commissionDetails?: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Scalars['String']
  deletedAt?: Maybe<Scalars['String']>
  description: Scalars['String']
  id: Scalars['Int']
  latitude: Scalars['Float']
  listingDocuments: Array<ListingDocument>
  listingImages: Array<ListingImage>
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: ListingSupplierType
  sustainabilityIds: Array<Scalars['Int']>
  updatedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  user: User
  userId: Scalars['Int']
  websiteUrl: Scalars['String']
}

export type ListingDocument = {
  __typename?: 'ListingDocument'
  deletedAt?: Maybe<Scalars['String']>
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  id: Scalars['Int']
  listingId: Scalars['Int']
  order: Scalars['Int']
  updatedAt: Scalars['String']
  uploadedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  url: Scalars['String']
  userId: Scalars['Int']
  uuid: Scalars['String']
}

export type ListingDocumentInput = {
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  order: Scalars['Int']
  userId: Scalars['Int']
}

export type ListingFilter = {
  capacity?: InputMaybe<Scalars['Int']>
  latitude?: InputMaybe<Scalars['Float']>
  listingId?: InputMaybe<Scalars['Int']>
  listingIds?: InputMaybe<Array<Scalars['Int']>>
  longitude?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
  radius?: InputMaybe<Scalars['Int']>
  supplierType?: InputMaybe<ListingSupplierType>
  sustainabilityIds?: InputMaybe<Array<Scalars['Int']>>
  userId?: InputMaybe<Scalars['Int']>
  userIds?: InputMaybe<Array<Scalars['Int']>>
}

export type ListingImage = {
  __typename?: 'ListingImage'
  deletedAt?: Maybe<Scalars['String']>
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  id: Scalars['Int']
  listingId: Scalars['Int']
  order: Scalars['Int']
  updatedAt: Scalars['String']
  uploadedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  url: Scalars['String']
  userId: Scalars['Int']
  uuid: Scalars['String']
}

export type ListingImageInput = {
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  order: Scalars['Int']
  userId: Scalars['Int']
}

export type ListingImageOrder = {
  imageId: Scalars['Int']
  order: Scalars['Int']
}

export enum ListingSupplierType {
  Accommodation = 'Accommodation',
  Activity = 'Activity',
  AdditionalSpend = 'Additional_spend',
  AudioVisual = 'Audio_visual',
  Branding = 'Branding',
  Catering = 'Catering',
  CorporateGifting = 'Corporate_gifting',
  Entertainment = 'Entertainment',
  EventManagement = 'Event_management',
  EventStaff = 'Event_staff',
  Florist = 'Florist',
  Furniture = 'Furniture',
  Merchandise = 'Merchandise',
  Photographers = 'Photographers',
  Props = 'Props',
  Sustainability = 'Sustainability',
  Travel = 'Travel',
}

export enum ManagementStatus {
  Booked = 'Booked',
  Live = 'Live',
  PastEvent = 'PastEvent',
  Released = 'Released',
}

export type MoveBookingInput = {
  bookingId: Scalars['Int']
  parentFolderId?: InputMaybe<Scalars['Int']>
  position: Scalars['Int']
}

export type MoveBookingsFolderInput = {
  bookingsFolderId: Scalars['Int']
  parentFolderId?: InputMaybe<Scalars['Int']>
  position: Scalars['Int']
}

export type Mutation = {
  __typename?: 'Mutation'
  /**
   * Links a given `twilioConsentUUID` to a specific `User`. This  is required for the `validationUuids`,
   * `hasValidatedEmail`, `hasValidatedPhone` and `consentedToTwilioTermsAndConditionsAt` fields on
   * the `User` object
   */
  ClaimTwilioConsentUUID?: Maybe<User>
  CreateFastTrackVenueAndSpace: Venue
  CreateFullListing: CreatedListing
  CreateListing: Listing
  CreateListingDocument: UploadedDocumentResponse
  CreateListingImage: UploadedImageResponse
  CreateSpaceSummary?: Maybe<Space>
  CreateVenue?: Maybe<Venue>
  DeleteAdditionalContact: AdditionalContact
  DeleteListing: Listing
  DeleteListingDocument: ListingDocument
  DeleteListingImage: ListingImage
  DeleteSpace?: Maybe<Space>
  DeleteSpaceDocument?: Maybe<S3DeletedResponse>
  DeleteSpacePhoto?: Maybe<S3DeletedResponse>
  DeleteVenue?: Maybe<Venue>
  DuplicateSpace?: Maybe<Space>
  MoveSpace?: Maybe<Space>
  PublishSpace?: Maybe<Space>
  /**
   * Records that a visitor, including unregistered users, has
   * consented to Twilios terms and condition. Returns a "Validation UUID",
   * which is required to call mutations which intergrate with Twilio
   */
  RecordTwilioConsent: Scalars['String']
  RejectSpace?: Maybe<Space>
  /**
   * Sends an email confirmation code to an email address.
   * A Validation UUID, aquired from the `RecordTwilioConsent` mutation or
   * the `validationUuid` field on `User`s, is required to ensure the visitor has
   * consented to the terms and conditions
   */
  RequestEmailValidationCode?: Maybe<Scalars['Boolean']>
  /**
   * Sends a phone number validation code to a phone number.
   * A Validation UUID, acquired from the `RecordTwilioConsent` mutation or
   * the `validationUuids` field on `User`s, is required to ensure the visitor has
   * consented to the terms and conditions.
   */
  RequestPhoneNumberValidationCode?: Maybe<Scalars['Boolean']>
  SubmitSpaceToReview?: Maybe<Space>
  TriggerBotResearchJob: BotResearchJobResponse
  UnpublishSpace?: Maybe<Space>
  UpdateCollections?: Maybe<Space>
  UpdateIsPrivate?: Maybe<Space>
  UpdateListing: Listing
  UpdateListingImagesOrder: Array<ListingImage>
  UpdateSpaceDocuments?: Maybe<Space>
  UpdateSpaceFacilities?: Maybe<Space>
  UpdateSpacePhotos?: Maybe<Space>
  UpdateSpaceStyles?: Maybe<Space>
  UpdateSpaceSummary?: Maybe<Space>
  UpdateSpatialConfiguration?: Maybe<Space>
  UpdateTour3dUrl?: Maybe<Space>
  UpdateVenue?: Maybe<Venue>
  UpdateVenueLeadFeedEnabledStatus: Venue
  /**
   * Verifies the `code` matches the code sent to the email address corresponding to the `twilioConsentUUID`.
   * This mutation returns true if the code is valid and false otherwise.
   * An error is thrown if the `twilioConsentUUID` is invalid or has not been used to request an email
   * validation code.
   */
  ValidateEmail?: Maybe<Scalars['Boolean']>
  /**
   * Verifies the `code` matches the code sent to the phone number corresponding to the `twilioConsentUUID`.
   * This mutation returns true if the code is valid and false otherwise.
   * An error is thrown if the `twilioConsentUUID` is invalid or has not been used to request a phone number
   * validation code.
   */
  ValidatePhoneNumber?: Maybe<Scalars['Boolean']>
  _?: Maybe<Scalars['Boolean']>
  assignUserToCompany: CompanyUser
  assignUserToRole: CompanyUser
  assignUsersToCompany: Array<Maybe<CompanyUser>>
  authenticateGuest: Session
  /** Create a new brief by BriefAttributes. */
  brief?: Maybe<Brief>
  cancelBooking: Booking
  cancelEvent: Event
  changeKanbanColumn: Event
  /** Claim a brief by ID. */
  claimBrief?: Maybe<Brief>
  completeBooking: Booking
  /** @deprecated complete event now deprecated on complex events model */
  completeEvent: Event
  createAdditionalSpendBooking: Booking
  createBooking: Booking
  createBookingsFolder: BookingsFolder
  createBusinessGuestAccount: Session
  createCompany: Company
  createEvent: Event
  createEventNote: EventNote
  createHostAccount: Session
  createProposal: Proposal
  createStandardGuestAccount: Session
  createSupplier: Supplier
  createSupplierAccount: Session
  createSupplierDeal: SupplierDeal
  declineInvitation: Invitation
  declineProposal: Proposal
  declineProposals: Array<Proposal>
  deleteBookingsFolder: BookingsFolder
  deleteEventNote: EventNote
  deleteSupplier: Supplier
  deleteSupplierDeal: SupplierDeal
  /** Disqualify a brief by ID. */
  disqualifyBrief?: Maybe<Brief>
  editCompany: Company
  getProposalDocumentUrl: ProposalSignedUrlData
  getSupplierDealAttachmentUrl: SupplierDealAttachmentSignedUrlData
  markInvitationRead: Invitation
  markUserAsHostById: User
  moveBooking: Booking
  moveBookingsFolder: BookingsFolder
  /** Release a brief by ID. */
  releaseBrief?: Maybe<Brief>
  releaseProposals: Array<Proposal>
  removeUserFromCompany: CompanyUser
  requestToBook: Proposal
  /** Resend the brief confirmatio to guest email by ID. */
  resendBriefConfirmation?: Maybe<Brief>
  /** Resend the claimed brief infomation to Hubspot again by ID. */
  resendBriefToHubspot?: Maybe<Brief>
  resetPassword: Scalars['Boolean']
  sendInvitations: Array<Invitation>
  triggerPasswordReset: Scalars['Boolean']
  undeclineInvitation: Invitation
  undeclineProposal: Proposal
  updateBooking: Booking
  updateBookingFromHubSpot: Booking
  updateBookingsFolder: BookingsFolder
  updateEvent: Event
  updateEventFromHubSpot: Booking
  updateEventNote: EventNote
  updateHost: HostInfo
  updatePreferredVenuesForCompany: Array<SelfServeVenue>
  updateProposal: Proposal
  updateProposalBaseDetails: Proposal
  updateSupplier: Supplier
  updateSupplierDeal: SupplierDeal
  updateUserPhoneNumber: User
  updateUserStatus: CompanyUser
}

export type MutationClaimTwilioConsentUuidArgs = {
  twilioConsentUUID: Scalars['String']
  userId: Scalars['Int']
}

export type MutationCreateFastTrackVenueAndSpaceArgs = {
  input: FastTrackVenueInput
}

export type MutationCreateFullListingArgs = {
  input: CreateFullListingInput
}

export type MutationCreateListingArgs = {
  input: CreateListingInput
}

export type MutationCreateListingDocumentArgs = {
  input?: InputMaybe<ListingDocumentInput>
  listingId: Scalars['Int']
}

export type MutationCreateListingImageArgs = {
  input?: InputMaybe<ListingImageInput>
  listingId: Scalars['Int']
}

export type MutationCreateSpaceSummaryArgs = {
  spaceSummary: SpaceSummaryInput
  venueId: Scalars['Int']
}

export type MutationCreateVenueArgs = {
  venue: VenueInput
}

export type MutationDeleteAdditionalContactArgs = {
  contactId: Scalars['Int']
  listingId: Scalars['Int']
}

export type MutationDeleteListingArgs = {
  listingId: Scalars['Int']
}

export type MutationDeleteListingDocumentArgs = {
  documentId: Scalars['Int']
  listingId: Scalars['Int']
}

export type MutationDeleteListingImageArgs = {
  imageId: Scalars['Int']
  listingId: Scalars['Int']
}

export type MutationDeleteSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationDeleteSpaceDocumentArgs = {
  s3Key: Scalars['String']
  spaceId: Scalars['Int']
}

export type MutationDeleteSpacePhotoArgs = {
  s3Key: Scalars['String']
  spaceId: Scalars['Int']
}

export type MutationDeleteVenueArgs = {
  id: Scalars['Int']
}

export type MutationDuplicateSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationMoveSpaceArgs = {
  newVenueId: Scalars['Int']
  spaceId: Scalars['Int']
}

export type MutationPublishSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationRejectSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationRequestEmailValidationCodeArgs = {
  email: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationRequestPhoneNumberValidationCodeArgs = {
  phoneNumber: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationSubmitSpaceToReviewArgs = {
  spaceId: Scalars['Int']
}

export type MutationTriggerBotResearchJobArgs = {
  venueId: Scalars['Int']
}

export type MutationUnpublishSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationUpdateCollectionsArgs = {
  collectionIds: Array<InputMaybe<Scalars['Int']>>
  spaceId: Scalars['Int']
}

export type MutationUpdateIsPrivateArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['Int']
}

export type MutationUpdateListingArgs = {
  input: UpdateListingInput
  listingId: Scalars['Int']
}

export type MutationUpdateListingImagesOrderArgs = {
  listingId: Scalars['Int']
  orders: Array<ListingImageOrder>
}

export type MutationUpdateSpaceDocumentsArgs = {
  spaceDocuments: Array<InputMaybe<SpaceDocumentInput>>
  spaceId: Scalars['Int']
}

export type MutationUpdateSpaceFacilitiesArgs = {
  spaceFacilityIds: Array<InputMaybe<Scalars['Int']>>
  spaceId: Scalars['Int']
}

export type MutationUpdateSpacePhotosArgs = {
  spaceId: Scalars['Int']
  spacePhotos: Array<InputMaybe<SpacePhotoInput>>
}

export type MutationUpdateSpaceStylesArgs = {
  spaceId: Scalars['Int']
  styleIds: Array<InputMaybe<StyleId>>
}

export type MutationUpdateSpaceSummaryArgs = {
  spaceId: Scalars['Int']
  spaceSummary: SpaceSummaryInput
}

export type MutationUpdateSpatialConfigurationArgs = {
  spaceId: Scalars['Int']
  spatialConfigurations: Array<InputMaybe<SpaceSpatialConfigurationInput>>
}

export type MutationUpdateTour3dUrlArgs = {
  spaceId: Scalars['Int']
  tour3dUrl?: InputMaybe<Scalars['String']>
}

export type MutationUpdateVenueArgs = {
  id: Scalars['Int']
  venue: VenueInput
}

export type MutationUpdateVenueLeadFeedEnabledStatusArgs = {
  id: Scalars['Int']
  leadFeedEnabledStatus: Scalars['Boolean']
}

export type MutationValidateEmailArgs = {
  code: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationValidatePhoneNumberArgs = {
  code: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationAssignUserToCompanyArgs = {
  input: AssignUserToCompanyInput
}

export type MutationAssignUserToRoleArgs = {
  input: AssignUserToRoleInput
}

export type MutationAssignUsersToCompanyArgs = {
  input: Array<InputMaybe<AssignUserToCompanyInput>>
}

export type MutationAuthenticateGuestArgs = {
  input: AuthenticateGuestInput
}

export type MutationBriefArgs = {
  params: BriefAttributes
}

export type MutationCancelBookingArgs = {
  bookingUuid: Scalars['ID']
  releaseReason: EventReleaseReason
}

export type MutationCancelEventArgs = {
  UUID: Scalars['ID']
  releaseReason: EventReleaseReason
}

export type MutationChangeKanbanColumnArgs = {
  UUID: Scalars['ID']
  newKanbanColumn: Scalars['String']
}

export type MutationClaimBriefArgs = {
  id: Scalars['Int']
}

export type MutationCompleteBookingArgs = {
  bookingUuid: Scalars['ID']
}

export type MutationCompleteEventArgs = {
  UUID: Scalars['ID']
}

export type MutationCreateAdditionalSpendBookingArgs = {
  input: CreateAdditionalSpendInput
}

export type MutationCreateBookingArgs = {
  input: CreateBookingInput
}

export type MutationCreateBookingsFolderArgs = {
  input: CreateBookingsFolderInput
}

export type MutationCreateBusinessGuestAccountArgs = {
  input: CreateBusinessGuestAccountInput
}

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput
}

export type MutationCreateEventArgs = {
  input: CreateEventInput
}

export type MutationCreateEventNoteArgs = {
  input: CreateEventNoteInput
}

export type MutationCreateHostAccountArgs = {
  input: CreateHostAccountInput
}

export type MutationCreateProposalArgs = {
  input: CreateProposalInput
}

export type MutationCreateStandardGuestAccountArgs = {
  input: CreateStandardGuestAccountInput
}

export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput
}

export type MutationCreateSupplierAccountArgs = {
  input: CreateSupplierAccountInput
}

export type MutationCreateSupplierDealArgs = {
  input: CreateSupplierDealInput
}

export type MutationDeclineInvitationArgs = {
  ID: Scalars['Int']
  reason: InvitationDeclinedReason
  reasonDetails?: InputMaybe<Scalars['String']>
}

export type MutationDeclineProposalArgs = {
  proposalId: Scalars['Int']
}

export type MutationDeclineProposalsArgs = {
  input: DeclineProposalsInput
}

export type MutationDeleteBookingsFolderArgs = {
  bookingsFolderId: Scalars['Int']
}

export type MutationDeleteEventNoteArgs = {
  input: DeleteEventNoteInput
}

export type MutationDeleteSupplierArgs = {
  input: DeleteSupplierInput
}

export type MutationDeleteSupplierDealArgs = {
  input: DeleteSupplierDealInput
}

export type MutationDisqualifyBriefArgs = {
  id: Scalars['Int']
}

export type MutationEditCompanyArgs = {
  input: EditCompanyInput
}

export type MutationGetProposalDocumentUrlArgs = {
  eventID: Scalars['Int']
  filename: Scalars['String']
}

export type MutationGetSupplierDealAttachmentUrlArgs = {
  eventID: Scalars['Int']
  filename: Scalars['String']
}

export type MutationMarkInvitationReadArgs = {
  ID: Scalars['Int']
}

export type MutationMarkUserAsHostByIdArgs = {
  id: Scalars['Int']
}

export type MutationMoveBookingArgs = {
  input: MoveBookingInput
}

export type MutationMoveBookingsFolderArgs = {
  input: MoveBookingsFolderInput
}

export type MutationReleaseBriefArgs = {
  id: Scalars['Int']
}

export type MutationReleaseProposalsArgs = {
  IDs: Array<Scalars['Int']>
}

export type MutationRemoveUserFromCompanyArgs = {
  input: RemoveUserFromCompanyInput
}

export type MutationRequestToBookArgs = {
  input: ReqToBookIn
}

export type MutationResendBriefConfirmationArgs = {
  id: Scalars['Int']
}

export type MutationResendBriefToHubspotArgs = {
  id: Scalars['Int']
}

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
}

export type MutationSendInvitationsArgs = {
  bookingId?: InputMaybe<Scalars['Int']>
  eventID: Scalars['Int']
  recipientIds: Array<Scalars['Int']>
  recipientType: ServiceProviderType
}

export type MutationTriggerPasswordResetArgs = {
  input: TriggerPasswordResetInput
}

export type MutationUndeclineInvitationArgs = {
  ID: Scalars['Int']
}

export type MutationUndeclineProposalArgs = {
  proposalId: Scalars['Int']
}

export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput
}

export type MutationUpdateBookingFromHubSpotArgs = {
  input?: InputMaybe<UpdateEventOrBookingFromHubSpotInput>
}

export type MutationUpdateBookingsFolderArgs = {
  input: UpdateBookingsFolderInput
}

export type MutationUpdateEventArgs = {
  input?: InputMaybe<UpdateEventInput>
}

export type MutationUpdateEventFromHubSpotArgs = {
  input?: InputMaybe<UpdateEventOrBookingFromHubSpotInput>
}

export type MutationUpdateEventNoteArgs = {
  input: UpdateEventNoteInput
}

export type MutationUpdateHostArgs = {
  args: UpdateHostArgs
}

export type MutationUpdatePreferredVenuesForCompanyArgs = {
  companyID: Scalars['Int']
  venueIDs: Array<Scalars['Int']>
}

export type MutationUpdateProposalArgs = {
  input: UpdateProposalInput
}

export type MutationUpdateProposalBaseDetailsArgs = {
  input: UpdateProposalBaseDetailsInput
}

export type MutationUpdateSupplierArgs = {
  input: UpdateSupplierInput
}

export type MutationUpdateSupplierDealArgs = {
  input: UpdateSupplierDealInput
}

export type MutationUpdateUserPhoneNumberArgs = {
  phoneNumber: Scalars['String']
  userID: Scalars['Int']
}

export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput
}

export type NearestTransit = {
  __typename?: 'NearestTransit'
  distanceKm?: Maybe<Scalars['Float']>
  station?: Maybe<Scalars['String']>
  transitType?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Page = {
  __typename?: 'Page'
  hasNextPage: Scalars['Boolean']
  number: Scalars['Int']
  size: Scalars['Int']
}

export type PageInput = {
  number: Scalars['Int']
  size: Scalars['Int']
}

/** Whether to sort paginated records in ascending or descending order of the sort column */
export enum PaginationOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type PreferredVenuesByCompany = {
  __typename?: 'PreferredVenuesByCompany'
  company: Company
  preferredVenues: Array<SelfServeVenue>
}

export type Proposal = {
  __typename?: 'Proposal'
  ID: Scalars['Int']
  UUID: Scalars['ID']
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  booking: Booking
  bookingId: Scalars['Int']
  convertedBaseCostTotal: ConvertedBaseCostTotal
  createdAt: Scalars['String']
  currency: SupportedCurrencyCode
  declinedAt?: Maybe<Scalars['String']>
  declinedBy?: Maybe<Scalars['Int']>
  declinedMessage?: Maybe<Scalars['String']>
  declinedReason?: Maybe<Array<ProposalDeclinedReason>>
  documents?: Maybe<Array<ProposalDocument>>
  event: Event
  eventID: Scalars['Int']
  extraCostItems?: Maybe<Array<ExtraCostItem>>
  fromDateTime: Scalars['String']
  hasPreferredVenue: Scalars['Boolean']
  hostID: Scalars['Int']
  invitation: Invitation
  invitationID: Scalars['Int']
  message?: Maybe<Scalars['String']>
  moreProposalsFromSameBooking?: Maybe<Array<Proposal>>
  proposerId: Scalars['Int']
  selectedPhotos: Array<SelectedServiceProviderPhoto>
  service?: Maybe<ServiceProvider>
  serviceId: Scalars['Int']
  serviceType: ServiceProviderType
  space?: Maybe<SelfServeSpace>
  /** spaceEmissionRate at the point in time that the Proposal was created */
  spaceEmissionRate?: Maybe<Scalars['Float']>
  /** spaceEpcRating at the point in time that the Proposal was created */
  spaceEpcRating?: Maybe<EpcRating>
  /** spaceEpcScore at the point in time that the Proposal was created */
  spaceEpcScore?: Maybe<Scalars['Int']>
  spaceID?: Maybe<Scalars['Int']>
  status: ProposalStatus
  toDateTime: Scalars['String']
  tourCoverUrl?: Maybe<Scalars['String']>
  tourUrl?: Maybe<Scalars['String']>
  withdrawn: Scalars['Boolean']
}

export type ProposalConvertedBaseCostTotalArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  inEventCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type ProposalMoreProposalsFromSameBookingArgs = {
  proposalUuid?: InputMaybe<Scalars['ID']>
}

export enum ProposalDeclinedReason {
  BriefChanged = 'BriefChanged',
  Budget = 'Budget',
  DatesAreNotSuitable = 'DatesAreNotSuitable',
  DoesNotMeetRequirements = 'DoesNotMeetRequirements',
  LocationChanged = 'LocationChanged',
}

export type ProposalDocument = {
  __typename?: 'ProposalDocument'
  ID: Scalars['Int']
  URL: Scalars['String']
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type ProposalDocumentInput = {
  URL?: InputMaybe<Scalars['String']>
  caption?: InputMaybe<Scalars['String']>
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type ProposalSignedUrlData = {
  __typename?: 'ProposalSignedUrlData'
  URL: Scalars['String']
  s3Key: Scalars['String']
}

export enum ProposalStatus {
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  AwaitingDecision = 'AwaitingDecision',
  Created = 'Created',
  Declined = 'Declined',
  Expired = 'Expired',
  Rejected = 'Rejected',
  RequestedToBook = 'RequestedToBook',
  SentToGuest = 'SentToGuest',
}

export type ProposalsFilter = {
  bookingUuid?: InputMaybe<Scalars['String']>
  invitationStatusFilter?: InputMaybe<InvitationFilterDeclined>
  restrictToUser?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<ProposalStatus>
}

export type Query = {
  __typename?: 'Query'
  AdditionalContact: AdditionalContact
  AdditionalContacts: Array<AdditionalContact>
  BBBE_collections: Array<Bbbe_Collection>
  BBBE_spaces: SpaceSearch
  Listing: Listing
  ListingDocument: ListingDocument
  ListingDocuments: Array<ListingDocument>
  ListingImage: ListingImage
  ListingImages: Array<ListingImage>
  Listings: Array<Listing>
  SustainabilityInitiatives: Array<SustainabilityInitiatives>
  _?: Maybe<Scalars['Boolean']>
  /** Query for AM Leads list table.  */
  amLeadsPage: LeadsPage
  /** Query for archived leads list table.  */
  archivedLeadsPage: LeadsPage
  bookings: Array<Booking>
  /** Query for Brief by ID.  */
  brief: Brief
  /** Query for whether a Brief qualifies for automation.  */
  briefIsAutomatable: BriefIsAutomatableResponse
  collection: Bbbe_Collection
  collections: Array<Collection>
  companies: Array<Company>
  domainInUse?: Maybe<Company>
  emissionsByPeriod: Array<EmissionsByPeriod>
  /**
   * The new, de-facto events query. Additional filters, such as UUID, user and host, in order to
   * replace the legacy getEventByX queries, are still to be added.
   */
  events: Array<Event>
  exchangeRates: Array<ExchangeRate>
  getAllHostsInfo: Array<HostInfo>
  /** @deprecated Use `companies` instead */
  getCompanies: Array<Company>
  getCompany: Company
  getEvent: Event
  getEventByUUID: Event
  /** @deprecated Use `events` query instead */
  getEvents?: Maybe<Array<Maybe<Event>>>
  getEventsByHost: Array<Event>
  getEventsByUser: Array<Event>
  getEventsByUsersTeams?: Maybe<Array<Maybe<Event>>>
  getGuestType: GuestType
  getHostInfo: HostInfo
  getInvitationDeclinedReasons: Array<InvitationDeclinedReason>
  getJwt?: Maybe<Scalars['String']>
  getPreferredVenuesByCompanyID: Array<SelfServeVenue>
  getPreferredVenuesByCompanyIDs: Array<PreferredVenuesByCompany>
  getProposalsByIDs: Array<Proposal>
  getProposalsByUUIDs: Array<Proposal>
  getRegionByCountry: Scalars['String']
  getRegionsByCountries: Array<Scalars['String']>
  getSession?: Maybe<Session>
  getSpaceDocumentSignedInfo?: Maybe<SpaceDocumentSignedInfo>
  getSpaceDocumentUrlFromS3Key?: Maybe<Scalars['String']>
  getSpacePhotoSignedInfo?: Maybe<SpacePhotoSignedInfo>
  getSpacePhotoUrlFromS3Key?: Maybe<Scalars['String']>
  getStyles: Array<Style>
  getSupplierTypes: Array<SupplierType>
  getSuppliers?: Maybe<Array<Supplier>>
  /** Get the Sustainability Initiatives for a Venue. */
  getSustainabilityInitiativesForVenue: Array<SustainabilityInitiative>
  getTeam: CompanyTeam
  /** Query for Leads with status.  */
  leads: Array<Brief>
  me?: Maybe<User>
  /** Returns a selection of ranked and filtered spaces according to passed input criteria */
  rankedSpaces: Array<Maybe<RankedSpace>>
  searchUsers: Array<SearchUser>
  searchUsersByEmail: Array<SearchUser>
  searchUsersByName: Array<SearchUser>
  spaceById?: Maybe<Space>
  spaceFacilities?: Maybe<Array<Maybe<SpaceFacility>>>
  spaceFacility?: Maybe<SpaceFacility>
  spaces: Array<Space>
  spacesPage?: Maybe<SpacesPage>
  spatialConfigurationTypes?: Maybe<Array<Maybe<Scalars['String']>>>
  supportedCurrencies: Array<Currency>
  sustainabilityInitiatives?: Maybe<Array<Maybe<SustainabilityInitiative>>>
  user: User
  userByEmail: User
  userId: Scalars['Int']
  userSpaceById?: Maybe<Space>
  userVenueById?: Maybe<Venue>
  userVenues?: Maybe<Array<Maybe<Venue>>>
  userVenuesByUserIdForAdmin?: Maybe<Array<Maybe<Venue>>>
  users: Array<User>
  venueById?: Maybe<Venue>
  venues?: Maybe<Array<Maybe<Venue>>>
  verifyToken?: Maybe<Scalars['Boolean']>
  versionInformation: VersionInformation
}

export type QueryAdditionalContactArgs = {
  id: Scalars['Int']
}

export type QueryAdditionalContactsArgs = {
  ids: Array<Scalars['Int']>
}

export type QueryBbbe_SpacesArgs = {
  page?: InputMaybe<Scalars['Int']>
  params: SearchParamsInput
}

export type QueryListingArgs = {
  filter: ListingFilter
}

export type QueryListingDocumentArgs = {
  documentId: Scalars['Int']
}

export type QueryListingDocumentsArgs = {
  documentIds: Array<Scalars['Int']>
}

export type QueryListingImageArgs = {
  imageId: Scalars['Int']
}

export type QueryListingImagesArgs = {
  imageIds: Array<Scalars['Int']>
}

export type QueryListingsArgs = {
  filter: ListingFilter
}

export type QueryAmLeadsPageArgs = {
  filter: AmLeadsFilter
  number: Scalars['Int']
  size: Scalars['Int']
}

export type QueryArchivedLeadsPageArgs = {
  number: Scalars['Int']
  size: Scalars['Int']
}

export type QueryBookingsArgs = {
  filter: BookingsFilter
}

export type QueryBriefArgs = {
  id: Scalars['ID']
}

export type QueryBriefIsAutomatableArgs = {
  briefParams: BriefAttributes
}

export type QueryCollectionArgs = {
  id: Scalars['String']
}

export type QueryCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilter>
}

export type QueryDomainInUseArgs = {
  country?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
}

export type QueryEmissionsByPeriodArgs = {
  filter?: InputMaybe<EmissionsFilter>
}

export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilter>
  pagination?: InputMaybe<EventsPagination>
  search?: InputMaybe<Scalars['String']>
}

export type QueryGetAllHostsInfoArgs = {
  args?: InputMaybe<GetAllHostsInfoArgs>
}

export type QueryGetCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilter>
}

export type QueryGetCompanyArgs = {
  ID: Scalars['Int']
}

export type QueryGetEventArgs = {
  ID: Scalars['Int']
}

export type QueryGetEventByUuidArgs = {
  UUID: Scalars['ID']
}

export type QueryGetEventsArgs = {
  filter?: InputMaybe<EventsFilter>
}

export type QueryGetEventsByHostArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  bucket?: InputMaybe<EventBucketFilterHost>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type QueryGetEventsByUserArgs = {
  active?: InputMaybe<EventActiveArg>
  sort?: InputMaybe<EventSortArg>
}

export type QueryGetGuestTypeArgs = {
  country?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export type QueryGetHostInfoArgs = {
  hostID: Scalars['Int']
}

export type QueryGetJwtArgs = {
  token?: InputMaybe<Scalars['String']>
}

export type QueryGetPreferredVenuesByCompanyIdArgs = {
  companyID: Scalars['Int']
}

export type QueryGetPreferredVenuesByCompanyIDsArgs = {
  companyIDs: Array<Scalars['Int']>
}

export type QueryGetProposalsByIDsArgs = {
  IDs: Array<Scalars['Int']>
}

export type QueryGetProposalsByUuiDsArgs = {
  UUIDs: Array<Scalars['ID']>
}

export type QueryGetRegionByCountryArgs = {
  country: Scalars['String']
}

export type QueryGetRegionsByCountriesArgs = {
  countries: Array<Scalars['String']>
}

export type QueryGetSessionArgs = {
  token?: InputMaybe<Scalars['String']>
}

export type QueryGetSpaceDocumentSignedInfoArgs = {
  filename: Scalars['String']
  spaceId: Scalars['Int']
}

export type QueryGetSpaceDocumentUrlFromS3KeyArgs = {
  s3Key: Scalars['String']
}

export type QueryGetSpacePhotoSignedInfoArgs = {
  filename: Scalars['String']
  spaceId: Scalars['Int']
}

export type QueryGetSpacePhotoUrlFromS3KeyArgs = {
  s3Key: Scalars['String']
}

export type QueryGetStylesArgs = {
  filter?: InputMaybe<StylesFiltersInput>
}

export type QueryGetSustainabilityInitiativesForVenueArgs = {
  input: GetSustainabilityInitiativesForVenueInput
}

export type QueryGetTeamArgs = {
  ID: Scalars['Int']
}

export type QueryLeadsArgs = {
  status?: InputMaybe<Scalars['String']>
}

export type QueryRankedSpacesArgs = {
  input?: InputMaybe<RankedSpacesInput>
}

export type QuerySearchUsersArgs = {
  contractCountry?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export type QuerySearchUsersByEmailArgs = {
  email: Scalars['String']
}

export type QuerySearchUsersByNameArgs = {
  name: Scalars['String']
}

export type QuerySpaceByIdArgs = {
  id: Scalars['Int']
}

export type QuerySpaceFacilityArgs = {
  id: Scalars['Int']
}

export type QuerySpacesArgs = {
  filter?: InputMaybe<SpaceFiltersInput>
}

export type QuerySpacesPageArgs = {
  filter?: InputMaybe<SpaceFiltersInput>
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<SpaceSortInput>
}

export type QueryUserArgs = {
  id: Scalars['Int']
}

export type QueryUserByEmailArgs = {
  email: Scalars['String']
}

export type QueryUserSpaceByIdArgs = {
  id: Scalars['Int']
}

export type QueryUserVenueByIdArgs = {
  id: Scalars['Int']
}

export type QueryUserVenuesByUserIdForAdminArgs = {
  userId: Scalars['Int']
}

export type QueryUsersArgs = {
  ids: Array<Scalars['Int']>
}

export type QueryVenueByIdArgs = {
  id: Scalars['Int']
}

export type QueryVenuesArgs = {
  filter?: InputMaybe<VenueFiltersInput>
}

export type QueryVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']>
}

export type RankedSpace = {
  __typename?: 'RankedSpace'
  /** The distance between the brief pin and the space in metres */
  distanceToBriefMetres: Scalars['Int']
  /** Details of which rankings were applied and the points assigned or removed by those rankings */
  rankingResult: Array<Maybe<RankedSpacesResult>>
  /** Details of the ranked space */
  space: Space
  /** Cumulative points after all rankings */
  totalPoints: Scalars['Int']
}

/** Capacity filter to use when filtering spaces. */
export type RankedSpacesCapacityFilter = {
  /**
   * The (minimum) attendees that a space must be able to hold, otherwise the space will be filtered out.
   *
   * When 'layoutId' is provided with a valid input that should not be ignored (see the 'layoutId' property), a space will be filtered
   * based on the attendees and the layout ID. If a space does not hold a number of attendees equal or exceeding
   * the input 'attendees' OR that dooes not support the specified layout (based on the input layout ID), it will be filtered out.
   *
   * When 'layoutId' is not provided with a valid input, or is provided with an input that should be ignored, a space will be filtered
   * based on the attendees only. If a space does not hold a number of attendees equal or exceeding the input 'attendees' (in any of its
   * layouts), it will be filtered out.
   */
  attendees: Scalars['Int']
  /**
   * The ID of a layout that a space must have, otherwise the space will be filtered out. If an invalid layout ID is provided,
   * it will be ignored.
   *
   * If a layout ID is not ignored, it is used in combination with 'attendees' (see the property). If a layout ID is
   * ignored, only attendees are used to filter a space.
   */
  layoutId: Scalars['String']
}

/** Filters out any Spaces which cannot host the requested event type(s) */
export type RankedSpacesEventTypeFilter = {
  /** The event type ID that a space must be able to host */
  eventTypeId: Scalars['Int']
  /** True to only return Smart Book spaces */
  smartBookOnly?: InputMaybe<Scalars['Boolean']>
}

export type RankedSpacesFilters = {
  capacity?: InputMaybe<RankedSpacesCapacityFilter>
  eventType?: InputMaybe<RankedSpacesEventTypeFilter>
  location?: InputMaybe<RankedSpacesLocationFilter>
}

/**
 * Input criteria include filters (remove spaces from consideration)
 * and rankings (assign or remove points to/from spaces);
 * after ranking the array is sorted by net ranking points,
 * where points are tied spaces are sorted by distance (closer to brief is higher)
 */
export type RankedSpacesInput = {
  /** Brief latitude and longitude */
  briefLatLon: BriefLatLon
  /** Filters remove spaces, removed spaces are not ranked or sorted. Filters are optional but highly recommended for speed and cost purposes */
  filters?: InputMaybe<RankedSpacesFilters>
  /** The number of spaces to be returned, the highest ranked */
  numberOfResults: Scalars['Int']
  /** Rankings assign or remove points to/from spaces */
  rankings: RankedSpacesRankings
}

/** Filters out any Spaces which are beyond the radius supplied */
export type RankedSpacesLocationFilter = {
  /**
   * Radius from the brief location in metres,
   * any spaces beyond this radius are filtered out
   */
  maximumRadiusMetres: Scalars['Int']
}

export type RankedSpacesRankings = {
  /** Assigns points to a space if it has some facilities matching those that were requested */
  spaceFacilities?: InputMaybe<SpaceFacilitiesRanking>
  /** Assigns points to a space if it is within a specified distance from a location */
  withinRadius?: InputMaybe<WithinRadiusRanking>
}

export type RankedSpacesResult = {
  __typename?: 'RankedSpacesResult'
  /** Additional details of how the points were awarded or subtracted */
  details?: Maybe<Array<Maybe<RankedSpacesResultDetails>>>
  /** Negative points removed by the ranking (note: these are not yet implemented) */
  negativePoints?: Maybe<Scalars['Int']>
  /** Cumulative points after ranking */
  netPoints: Scalars['Int']
  /** Positive points assigned by the ranking */
  positivePoints?: Maybe<Scalars['Int']>
  /** The name of the ranking applied */
  rankingName: Scalars['String']
}

export type RankedSpacesResultDetails = SpaceFacilitiesRankingResultDetails

export type RemoveUserFromCompanyInput = {
  ID: Scalars['Int']
}

export type ReqToBookIn = {
  costItems: Array<CostItemQtyIn>
  proposalID: Scalars['Int']
}

export type ResetPasswordInput = {
  email: Scalars['String']
  password: Scalars['String']
  resetPasswordToken: Scalars['String']
}

export type S3DeletedResponse = {
  __typename?: 'S3DeletedResponse'
  deleted: Scalars['Boolean']
  spaceId: Scalars['Int']
}

export type SearchParamsInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  budget: Scalars['Int']
  capacities: Scalars['Int']
  catering?: InputMaybe<Array<Scalars['String']>>
  collection?: InputMaybe<Scalars['String']>
  collectionName?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  eventName?: InputMaybe<Scalars['String']>
  facilities?: InputMaybe<Array<Scalars['String']>>
  flexibleDates?: InputMaybe<Scalars['Boolean']>
  fromDate?: InputMaybe<Scalars['String']>
  fromTime?: InputMaybe<Scalars['String']>
  hostId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Int']>
  lat: Scalars['String']
  layouts?: InputMaybe<Scalars['String']>
  location: Scalars['String']
  lon: Scalars['String']
  public?: InputMaybe<Scalars['Boolean']>
  radius?: InputMaybe<Scalars['Int']>
  spaceId?: InputMaybe<Scalars['String']>
  toDate?: InputMaybe<Scalars['String']>
  toTime?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['Int']>
}

export type SearchUser = {
  __typename?: 'SearchUser'
  ID: Scalars['Int']
  companyID?: Maybe<Scalars['Int']>
  companyName?: Maybe<Scalars['String']>
  country: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  id: Scalars['Int']
  lastName: Scalars['String']
  regions: Array<Scalars['String']>
  roles: Array<Maybe<Scalars['String']>>
}

export enum SeatingLayout {
  Boardroom = 'boardroom',
  Cabaret = 'cabaret',
  Classroom = 'classroom',
  DinnerRounds = 'dinnerRounds',
  NotSure = 'notSure',
  Seating = 'seating',
  Standing = 'standing',
  Theatre = 'theatre',
  UShaped = 'uShaped',
}

export type SelectedServiceProviderPhoto = {
  __typename?: 'SelectedServiceProviderPhoto'
  id: Scalars['Int']
  url: Scalars['String']
}

export type SelfServeSpace = {
  __typename?: 'SelfServeSpace'
  ID?: Maybe<Scalars['Int']>
  description?: Maybe<Scalars['String']>
  hostContact: HostContact
  spaceDocuments?: Maybe<Array<Maybe<SpaceDocument>>>
  spaceFeatures?: Maybe<Array<SelfServeSpaceFeature>>
  spaceName?: Maybe<Scalars['String']>
  spacePhotos?: Maybe<Array<SelfServeSpacePhoto>>
  spatialConfigurations?: Maybe<Array<SelfServeSpatialConfiguration>>
  tour3dUrl?: Maybe<Scalars['String']>
  user?: Maybe<User>
  venue?: Maybe<SelfServeVenue>
}

export type SelfServeSpaceFeature = {
  __typename?: 'SelfServeSpaceFeature'
  ID?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type SelfServeSpacePhoto = {
  __typename?: 'SelfServeSpacePhoto'
  id?: Maybe<Scalars['Int']>
  position?: Maybe<Scalars['Int']>
  url?: Maybe<Scalars['String']>
}

export type SelfServeSpatialConfiguration = {
  __typename?: 'SelfServeSpatialConfiguration'
  ID?: Maybe<Scalars['Int']>
  capacity?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type SelfServeVenue = {
  __typename?: 'SelfServeVenue'
  ID?: Maybe<Scalars['Int']>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  nearestTransit?: Maybe<NearestTransit>
  postalCode?: Maybe<Scalars['String']>
}

export type ServiceProvider = SelfServeSpace | SupplierListing

export enum ServiceProviderType {
  Space = 'space',
  Supplier = 'supplier',
}

export type Session = {
  __typename?: 'Session'
  jwt: Scalars['String']
  refreshToken?: Maybe<Scalars['String']>
  user: User
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Space = {
  __typename?: 'Space'
  city: Scalars['String']
  collectionIds?: Maybe<Array<Scalars['Int']>>
  collections?: Maybe<Array<Collection>>
  coordinates: SpaceCoordinates
  country: Scalars['String']
  dateVenueCreated: Scalars['String']
  deleted?: Maybe<Scalars['Boolean']>
  deletedAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  energyPerformance?: Maybe<SpaceEnergyPerformance>
  floorArea?: Maybe<Scalars['Float']>
  host: Host
  id?: Maybe<Scalars['ID']>
  isPrivate?: Maybe<Scalars['Boolean']>
  lastDigitalProposalProposalDate: Scalars['String']
  latitude: Scalars['Float']
  location?: Maybe<Scalars['String']>
  longitude: Scalars['Float']
  map?: Maybe<Array<SpaceMap>>
  maximumSpaceCapacity: Scalars['Int']
  minimumSpaceCapacity: Scalars['Int']
  name: Scalars['String']
  numberOfDigitalProposalsInvites: Scalars['Int']
  numberOfDigitalProposalsProposals: Scalars['Int']
  numberOfSmartBookInvites: Scalars['Int']
  preferredCompanies: Array<Maybe<Scalars['String']>>
  publishedAt?: Maybe<Scalars['DateTime']>
  publishedBy?: Maybe<User>
  publishedById?: Maybe<Scalars['Int']>
  rejectedAt?: Maybe<Scalars['DateTime']>
  rejectedBy?: Maybe<User>
  rejectedById?: Maybe<Scalars['Int']>
  smartBookEventTypes: Array<Maybe<Scalars['Int']>>
  spaceDocuments?: Maybe<Array<SpaceDocument>>
  spaceFacilities?: Maybe<Array<SpaceFacility>>
  spaceName?: Maybe<Scalars['String']>
  spacePhotos: Array<SpacePhoto>
  spatialConfigurations?: Maybe<Array<SpatialConfiguration>>
  status?: Maybe<SpaceStatus>
  styleIds: Array<StyleId>
  styles?: Maybe<Array<Style>>
  submittedAt?: Maybe<Scalars['DateTime']>
  tour3dUrl?: Maybe<Scalars['String']>
  user?: Maybe<User>
  userId: Scalars['Int']
  venue?: Maybe<Venue>
  venueId?: Maybe<Scalars['Int']>
  venueName?: Maybe<Scalars['String']>
}

export type SpaceCoordinates = {
  __typename?: 'SpaceCoordinates'
  lat: Scalars['Float']
  lng: Scalars['Float']
}

/** A document for a space, such as a floorplan. This type is shared across applications. */
export type SpaceDocument = {
  __typename?: 'SpaceDocument'
  caption?: Maybe<Scalars['String']>
  /** @deprecated SpaceDocumentType is deprecated. Use 'SpaceDocumentTag' instead. */
  documentType?: Maybe<SpaceDocumentType>
  filename?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  position?: Maybe<Scalars['Int']>
  s3Key?: Maybe<Scalars['String']>
  tag?: Maybe<SpaceDocumentTag>
  url?: Maybe<Scalars['String']>
}

export type SpaceDocumentInput = {
  caption?: InputMaybe<Scalars['String']>
  documentType?: InputMaybe<SpaceDocumentType>
  filename: Scalars['String']
  s3Key: Scalars['String']
  tag?: InputMaybe<SpaceDocumentTag>
}

export type SpaceDocumentSignedInfo = {
  __typename?: 'SpaceDocumentSignedInfo'
  s3Key?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

/**
 * A tag for a space document that defines the specific HeadBox "type" of a document, for example a floorplan.
 * This enum is shared across applications.
 */
export enum SpaceDocumentTag {
  Floorplan = 'FLOORPLAN',
  Menu = 'MENU',
  Specifications = 'SPECIFICATIONS',
  SustainabilityDocumentation = 'SUSTAINABILITY_DOCUMENTATION',
}

/**
 * DEPRECATED
 * The type of the document.
 * This enum is shared across applications.
 */
export enum SpaceDocumentType {
  Facilities = 'facilities',
  FloorPlans = 'floor_plans',
  Generic = 'generic',
  Menu = 'menu',
  TermsAndConditions = 'terms_and_conditions',
}

/**
 * Warning!!!
 *
 * This can seriously slow down queries for large numbers of spaces.
 *
 * It has been limited and will throw an error on querys for more than 200 spaces.
 */
export type SpaceEnergyPerformance = {
  __typename?: 'SpaceEnergyPerformance'
  /** kg of CO2 per hour */
  emissionRate?: Maybe<Scalars['Float']>
  rating?: Maybe<Scalars['String']>
  score?: Maybe<Scalars['Int']>
}

export type SpaceFacilitiesRanking = {
  /** Number of positive points to be assigned if a space has a matching facility */
  positivePoints: Scalars['Int']
  /** Space facility IDs to be ranked */
  spaceFacilityIds: Array<Scalars['Int']>
}

export type SpaceFacilitiesRankingResultDetails = {
  __typename?: 'SpaceFacilitiesRankingResultDetails'
  /** Number of positive points awarded as a result of matching */
  positivePoints: Scalars['Int']
  /** Space facility which matched */
  spaceFacility: SpaceFacility
}

/** Consistent, business-defined properties of spaces that users can request for their events, such as 'natural light', 'parking facilities', etc. */
export type SpaceFacility = {
  __typename?: 'SpaceFacility'
  facilityCategory?: Maybe<FacilityCategory>
  facilityCategoryId?: Maybe<Scalars['Int']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['Int']
  name: Scalars['String']
  position?: Maybe<Scalars['Int']>
}

export type SpaceFeature = {
  __typename?: 'SpaceFeature'
  featureCategory?: Maybe<FeatureCategory>
  featureCategoryId?: Maybe<Scalars['Int']>
  icon?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
}

export type SpaceFiltersInput = {
  collectionIds?: InputMaybe<Array<Scalars['Int']>>
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  deleted?: InputMaybe<Scalars['Boolean']>
  geolocation?: InputMaybe<GeolocationFilterInput>
  ids?: InputMaybe<Array<Scalars['Int']>>
  isPrivate?: InputMaybe<Scalars['Boolean']>
  published?: InputMaybe<Scalars['Boolean']>
  rejected?: InputMaybe<Scalars['Boolean']>
  searchTerms?: InputMaybe<Scalars['String']>
  submitted?: InputMaybe<Scalars['Boolean']>
  userId?: InputMaybe<Scalars['Int']>
  userIds?: InputMaybe<Array<Scalars['Int']>>
}

export type SpaceMap = {
  __typename?: 'SpaceMap'
  coordinates: SpaceCoordinates
  id: Scalars['ID']
  location?: Maybe<Scalars['String']>
  onPage: Scalars['Boolean']
}

export type SpacePhoto = {
  __typename?: 'SpacePhoto'
  detail: Scalars['String']
  eventTypeTags: Array<Collection>
  filename?: Maybe<Scalars['String']>
  filenameProcessing?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  layoutTagKeys: Array<Scalars['String']>
  listings: Scalars['String']
  position: Scalars['Int']
  s3Key?: Maybe<Scalars['String']>
  squareThumb: Scalars['String']
  thumb: Scalars['String']
  url: Scalars['String']
}

export type SpacePhotoInput = {
  eventTypeTagIds: Array<Scalars['Int']>
  filename: Scalars['String']
  layoutTagKeys: Array<Scalars['String']>
  s3Key: Scalars['String']
}

export type SpacePhotoSignedInfo = {
  __typename?: 'SpacePhotoSignedInfo'
  s3Key?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type SpaceSearch = {
  __typename?: 'SpaceSearch'
  listView: Array<Space>
  mapView: Array<SpaceMap>
}

export enum SpaceSortField {
  Id = 'id',
  PublishedAt = 'publishedAt',
  RejectedAt = 'rejectedAt',
  SubmittedAt = 'submittedAt',
}

export type SpaceSortInput = {
  direction: SortDirection
  field: SpaceSortField
}

export type SpaceSpatialConfigurationInput = {
  capacity: Scalars['Int']
  name: Scalars['String']
}

export enum SpaceStatus {
  Complete = 'complete',
  Overview = 'overview',
  Published = 'published',
  Reviewed = 'reviewed',
  UnderReview = 'under_review',
}

export type SpaceSummaryInput = {
  description: Scalars['String']
  floorArea?: InputMaybe<Scalars['Float']>
  name: Scalars['String']
}

export type SpacesPage = {
  __typename?: 'SpacesPage'
  page?: Maybe<Page>
  rows?: Maybe<Array<Space>>
  totalPages?: Maybe<Scalars['Int']>
  totalRows?: Maybe<Scalars['Int']>
}

export type SpatialConfiguration = {
  __typename?: 'SpatialConfiguration'
  capacity?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

/** Full type merged into the schema in the gateway */
export type Style = {
  __typename?: 'Style'
  emoji?: Maybe<Scalars['String']>
  id: Scalars['String']
  label?: Maybe<Scalars['String']>
}

export enum StyleId {
  BlankCanvas = 'blank_canvas',
  Casual = 'casual',
  Formal = 'formal',
  Fun = 'fun',
  Industrial = 'industrial',
  Lively = 'lively',
  Luxury = 'luxury',
  Modern = 'modern',
  Professional = 'professional',
  Quiet = 'quiet',
  Quirky = 'quirky',
  Simple = 'simple',
  Social = 'social',
  Traditional = 'traditional',
}

export type StylesFiltersInput = {
  id?: InputMaybe<StyleId>
  ids?: InputMaybe<Array<InputMaybe<StyleId>>>
}

export type Supplier = {
  __typename?: 'Supplier'
  ID: Scalars['Int']
  email: Scalars['String']
  name: Scalars['String']
  type: SupplierType
}

export type SupplierDeal = {
  __typename?: 'SupplierDeal'
  ID: Scalars['Int']
  attachments?: Maybe<Array<SupplierDealAttachment>>
  cost?: Maybe<Scalars['Int']>
  createdAt: Scalars['String']
  currency: Scalars['String']
  event: Event
  message?: Maybe<Scalars['String']>
  supplier: Supplier
  updatedAt: Scalars['String']
}

export type SupplierDealAttachment = {
  __typename?: 'SupplierDealAttachment'
  ID: Scalars['Int']
  URL: Scalars['String']
  caption?: Maybe<Scalars['String']>
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type SupplierDealAttachmentSignedUrlData = {
  __typename?: 'SupplierDealAttachmentSignedUrlData'
  URL: Scalars['String']
  s3Key: Scalars['String']
}

export type SupplierListing = {
  __typename?: 'SupplierListing'
  additionalContacts?: Maybe<Array<Maybe<AdditionalContact>>>
  address: Scalars['String']
  commissionDetails?: Maybe<Scalars['String']>
  country: Scalars['String']
  description?: Maybe<Scalars['String']>
  id: Scalars['Int']
  latitude: Scalars['Float']
  listingDocuments: Array<ListingDocument>
  listingImages: Array<ListingImage>
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: SupplierType
  sustainabilityIds: Array<Scalars['Int']>
  user?: Maybe<User>
  websiteUrl: Scalars['String']
}

export enum SupplierType {
  /** @deprecated Move to Event type */
  Accommodation = 'Accommodation',
  Activity = 'Activity',
  AdditionalSpend = 'AdditionalSpend',
  /** @deprecated Use 'AdditionalSpend'. */
  AdditionalSpent = 'AdditionalSpent',
  AudioVisual = 'AudioVisual',
  Branding = 'Branding',
  Catering = 'Catering',
  CorporateGifting = 'CorporateGifting',
  Entertainment = 'Entertainment',
  EventManagement = 'EventManagement',
  EventStaff = 'EventStaff',
  Florist = 'Florist',
  Furniture = 'Furniture',
  Merchandise = 'Merchandise',
  Photographers = 'Photographers',
  Props = 'Props',
  Sustainability = 'Sustainability',
  Travel = 'Travel',
  Venue = 'venue',
}

/** The order of these enums are important, please ensure correct order when adding new currency */
export enum SupportedCurrencyCode {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Idr = 'IDR',
  Nzd = 'NZD',
  Php = 'PHP',
  Sgd = 'SGD',
  Usd = 'USD',
}

export type SustainabilityInitiative = {
  __typename?: 'SustainabilityInitiative'
  category: Scalars['String']
  id: Scalars['Int']
  label: Scalars['String']
}

export enum SustainabilityInitiativeCategory {
  Catering = 'CATERING',
  DiversityAndInclusion = 'DIVERSITY_AND_INCLUSION',
  Energy = 'ENERGY',
  PoliciesAndCredentials = 'POLICIES_AND_CREDENTIALS',
  Purchasing = 'PURCHASING',
  Travel = 'TRAVEL',
  WasteAndRecycling = 'WASTE_AND_RECYCLING',
  Water = 'WATER',
}

export type SustainabilityInitiatives = {
  __typename?: 'SustainabilityInitiatives'
  category: Scalars['String']
  initiatives: Array<SustainabilityInitiative>
}

export type Team = {
  __typename?: 'Team'
  ID: Scalars['Int']
  id: Scalars['Int']
  name: Scalars['String']
}

export type TriggerPasswordResetInput = {
  email: Scalars['String']
}

export type UpdateBookingInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees?: InputMaybe<Scalars['Int']>
  bookingFolderId?: InputMaybe<Scalars['Int']>
  bookingRequestedAt?: InputMaybe<Scalars['String']>
  bookingRequestedBy?: InputMaybe<Scalars['Int']>
  budget?: InputMaybe<Scalars['Int']>
  cateringNeeds?: InputMaybe<Scalars['String']>
  closedAmount?: InputMaybe<Scalars['Int']>
  closedAmountCompanyCurrency?: InputMaybe<Scalars['Int']>
  closedAmountExTax?: InputMaybe<Scalars['Int']>
  closedAt?: InputMaybe<Scalars['String']>
  commissionPercentage?: InputMaybe<Scalars['Float']>
  commissionableAmount?: InputMaybe<Scalars['Int']>
  completedAt?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  decisionDate?: InputMaybe<Scalars['String']>
  eventTypeId?: InputMaybe<Scalars['Int']>
  fastTrackSupplierEmail?: InputMaybe<Scalars['String']>
  fastTrackSupplierName?: InputMaybe<Scalars['String']>
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDateTime?: InputMaybe<Scalars['String']>
  fxRate?: InputMaybe<Scalars['Float']>
  hubspotID?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  isAdditionalSpendBooking?: InputMaybe<Scalars['Boolean']>
  isCommisionable?: InputMaybe<Scalars['Boolean']>
  isFlexibleWithDates?: InputMaybe<Scalars['Boolean']>
  lat?: InputMaybe<Scalars['Float']>
  layoutId?: InputMaybe<Scalars['String']>
  lifecycleStage?: InputMaybe<LifecycleStage>
  location?: InputMaybe<Scalars['String']>
  lon?: InputMaybe<Scalars['Float']>
  lostAt?: InputMaybe<Scalars['String']>
  lostReason?: InputMaybe<Scalars['String']>
  marketPrice?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  parentBookingId?: InputMaybe<Scalars['Int']>
  paymentsInvoiceReference?: InputMaybe<Scalars['String']>
  positionIndex?: InputMaybe<Scalars['Int']>
  processingFeePercentage?: InputMaybe<Scalars['Float']>
  radius?: InputMaybe<Scalars['Float']>
  releaseReason?: InputMaybe<EventReleaseReason>
  requestedToBookAt?: InputMaybe<Scalars['String']>
  solutionsInvoiceReference?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  styleIds?: InputMaybe<Array<Scalars['String']>>
  submittedBy?: InputMaybe<Scalars['Int']>
  supplierType?: InputMaybe<Scalars['String']>
  takeOver?: InputMaybe<Scalars['Boolean']>
  takeOverFee?: InputMaybe<Scalars['Int']>
  takeOverFeePercentage?: InputMaybe<Scalars['Float']>
  toDateTime?: InputMaybe<Scalars['String']>
}

export type UpdateBookingsFolderInput = {
  budget?: InputMaybe<Scalars['Int']>
  eventTypeId?: InputMaybe<Scalars['Int']>
  id: Scalars['Int']
  name?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  parentFolderId?: InputMaybe<Scalars['Int']>
  position?: InputMaybe<Scalars['Int']>
}

export type UpdateEventInput = {
  UUID: Scalars['ID']
  actualEventMgmtFee?: InputMaybe<Scalars['Int']>
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees: Scalars['Int']
  budget: Scalars['Int']
  cateringNeeds?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  currency: Scalars['String']
  decisionDate?: InputMaybe<Scalars['String']>
  estimatedEventMgmtFee?: InputMaybe<Scalars['Int']>
  eventTypeID: Scalars['Int']
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDateTime: Scalars['String']
  isFlexibleWithDates?: InputMaybe<Scalars['Boolean']>
  lat: Scalars['String']
  layoutID: Scalars['String']
  location: Scalars['String']
  lon: Scalars['String']
  name: Scalars['String']
  ownerId?: InputMaybe<Scalars['Int']>
  radius?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIDs: Array<Scalars['Int']>
  styleIDs?: InputMaybe<Array<Scalars['String']>>
  team?: InputMaybe<Scalars['Int']>
  toDateTime: Scalars['String']
}

export type UpdateEventNoteInput = {
  note: Scalars['String']
  noteId: Scalars['Int']
}

export type UpdateEventOrBookingFromHubSpotInput = {
  country: Scalars['String']
  hubspotID: Scalars['String']
}

export type UpdateHostArgs = {
  addEventTypeIDs: Array<Scalars['Int']>
  hostID: Scalars['Int']
  removeEventTypeIDs: Array<Scalars['Int']>
}

export type UpdateListingInput = {
  address?: InputMaybe<Scalars['String']>
  commissionDetails?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  existingAdditionalContacts?: InputMaybe<Array<AdditionalContactUpdateInput>>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  maxEventCapacity?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  newAdditionalContacts?: InputMaybe<Array<AdditionalContactInput>>
  serviceArea?: InputMaybe<Scalars['Int']>
  supplierType?: InputMaybe<ListingSupplierType>
  sustainabilityIds?: InputMaybe<Array<Scalars['Int']>>
  websiteUrl?: InputMaybe<Scalars['String']>
}

export type UpdateProposalBaseDetailsInput = {
  UUID: Scalars['ID']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  currency: Scalars['String']
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  message?: InputMaybe<Scalars['String']>
  selectedPhotos?: InputMaybe<Array<Scalars['Int']>>
}

export type UpdateProposalInput = {
  UUID: Scalars['ID']
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  currency: Scalars['String']
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  documents?: InputMaybe<Array<ProposalDocumentInput>>
  extraCostItems?: InputMaybe<Array<ExtraCostItemInput>>
  fromDateTime: Scalars['String']
  message?: InputMaybe<Scalars['String']>
  selectedPhotos?: InputMaybe<Array<Scalars['Int']>>
  toDateTime: Scalars['String']
}

export type UpdateSupplierDealInput = {
  ID: Scalars['Int']
  attachmentFilePaths?: InputMaybe<Array<Scalars['String']>>
  cost?: InputMaybe<Scalars['Int']>
  currency?: InputMaybe<Scalars['String']>
  message?: InputMaybe<Scalars['String']>
  supplierID?: InputMaybe<Scalars['Int']>
}

export type UpdateSupplierInput = {
  ID: Scalars['Int']
  email?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  type?: InputMaybe<SupplierType>
}

export type UpdateUserStatusInput = {
  ID: Scalars['Int']
  status: CompanyUserStatus
}

export type UploadedDocumentResponse = {
  __typename?: 'UploadedDocumentResponse'
  s3Url: Scalars['String']
}

export type UploadedImageResponse = {
  __typename?: 'UploadedImageResponse'
  s3Url: Scalars['String']
}

export type User = {
  __typename?: 'User'
  ID: Scalars['Int']
  avatar?: Maybe<Scalars['String']>
  avatars: Avatars
  company?: Maybe<Company>
  companyCountry?: Maybe<Scalars['String']>
  companyID?: Maybe<Scalars['Int']>
  companyId: Scalars['Int']
  companyLogo?: Maybe<Scalars['String']>
  companyLogoUrl?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  consentedToTwilioTermsAndCondition: Scalars['Boolean']
  contactNumber?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  countryPermissions: Array<Maybe<Scalars['String']>>
  currency: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  /**
   * Indicates if the user has validated their phone number.
   * Parameter `phoneNumber` is optional and can be used to check validation for a specific number.
   * If not provided, it checks the user's `contactNumber`.
   */
  hasValidatedPhoneNumber: Scalars['Boolean']
  id: Scalars['Int']
  isDirectEnquiryEnabled: Scalars['Boolean']
  isPowerHost: Scalars['Boolean']
  jobTitle?: Maybe<Scalars['String']>
  lastName: Scalars['String']
  mobileNumber?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  regions: Array<Scalars['String']>
  roles: Array<Scalars['String']>
  teams?: Maybe<Array<UserTeam>>
  twilioConsentUUID?: Maybe<Scalars['String']>
  widgetBacklinkMandatory?: Maybe<Scalars['Boolean']>
}

export type UserHasValidatedPhoneNumberArgs = {
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type UserTeam = {
  __typename?: 'UserTeam'
  id: Scalars['Int']
  name: Scalars['String']
}

export type Venue = {
  __typename?: 'Venue'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  deleted?: Maybe<Scalars['Boolean']>
  deletedAt?: Maybe<Scalars['DateTime']>
  googleAddress?: Maybe<GoogleAddress>
  googleOpeningHours?: Maybe<Array<Maybe<Scalars['String']>>>
  googlePlaceID?: Maybe<Scalars['String']>
  googleRating?: Maybe<Scalars['Float']>
  googleReviewsEnabled?: Maybe<Scalars['Boolean']>
  googleTotalRatings?: Maybe<Scalars['Int']>
  hasPublishedSpaces?: Maybe<Scalars['Boolean']>
  id: Scalars['Int']
  lastResearchDate?: Maybe<Scalars['DateTime']>
  latitude?: Maybe<Scalars['Float']>
  leadFeedEnabled: Scalars['Boolean']
  longDesc?: Maybe<Scalars['String']>
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  researchData?: Maybe<Scalars['String']>
  shortDesc?: Maybe<Scalars['String']>
  spaces?: Maybe<Array<Space>>
  state?: Maybe<Scalars['String']>
  sustainabilityInitiativeIds?: Maybe<Array<Scalars['Int']>>
  sustainabilityInitiatives?: Maybe<Array<SustainabilityInitiative>>
  totalFloorArea?: Maybe<Scalars['Float']>
  user?: Maybe<User>
  userId: Scalars['Int']
}

export type VenueFiltersInput = {
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  geolocation?: InputMaybe<GeolocationFilterInput>
  ids?: InputMaybe<Array<Scalars['Int']>>
  leadFeedEnabled?: InputMaybe<Scalars['Boolean']>
  publishedSpacesOnly?: InputMaybe<Scalars['Boolean']>
  userIds?: InputMaybe<Array<Scalars['Int']>>
  venueNameLike?: InputMaybe<Scalars['String']>
}

export type VenueInput = {
  addressLine1: Scalars['String']
  addressLine2?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  country: Scalars['String']
  googlePlaceID?: InputMaybe<Scalars['String']>
  googleReviewsEnabled?: InputMaybe<Scalars['Boolean']>
  latitude: Scalars['Float']
  leadFeedEnabled?: InputMaybe<Scalars['Boolean']>
  longitude: Scalars['Float']
  name: Scalars['String']
  placeIDMigrated?: InputMaybe<Scalars['Boolean']>
  postalCode: Scalars['String']
  state?: InputMaybe<Scalars['String']>
  sustainabilityInitiativeIds?: InputMaybe<Array<Scalars['Int']>>
  totalFloorArea?: InputMaybe<Scalars['Float']>
}

export type VersionInformation = {
  __typename?: 'VersionInformation'
  name: Scalars['String']
  semver: Scalars['String']
}

export type WithinRadiusRanking = {
  /** Number of positive points to be assigned if a space is within the specified radius */
  positivePoints: Scalars['Int']
  /** Distance from the brief location in metres */
  withinRadiusMetres: Scalars['Int']
}
